const translations = {
  en: {
    newQuipReleaseNotificationTitle: 'Login (old QuIP software system)',
    newQuipReleaseNotification: 'Please note: Registration for proficiency tests will take place in our new {webshop} starting in 2026. If you are a new customer, you will need two separate user accounts: QuIP Customer Center (QCC): Required to order our proficiency tests. Old QuIP Software System: Required to enter results, view your evaluations, and download certificates.',
    genericSaveMessage: 'Changes Saved',
    genericErrorMessage: 'Sorry, an Error occured',
    confirm: 'Confirm',
    genericClose: 'Close',
    genericCancel: 'Cancel',
    genericDelete: 'Delete',
    genericUploadFile: 'Upload File',
    save: 'Save',
    back: 'Back',
    next: 'Next',
    yes: 'yes',
    no: 'no',
    warning: 'Warning',
    duplicate: 'duplicate',
    none: 'None',
    done: 'Done',
    edit: 'Edit',
    approve: 'Approve',
    add: 'Add',
    note: 'Note',
    groundtruthNo: 'groundTruth No.',
    section: 'Section: ',
    overall: 'Overall: ',
    pass: 'Passed',
    fail: 'Failed',
    notFinalized: 'Not Finalized',
    'trialsTablabel.individual': 'Individual',
    'trialsTablabel.institute': 'Institute',
    'print.choosePrintMode': 'Choose Print Mode',
    'print.printSummary': 'Print my submission',
    'print.printWhole': 'Print survey form',
    'print.pageLayout': 'Page Layout',
    'print.portrait': 'Portrait',
    'print.landscape': 'Landscape',
    'print.pagebreak': 'Pagebreak',
    'salutation.mr': 'Mr.',
    'salutation.ms': 'Ms.',
    'position.employee': 'Employee',
    'position.headOfInstitute': 'Head of Institute',
    'changePassword.oldPasswordLabel': 'Old Password',
    'changePassword.newPasswordLabel': 'New Password',
    'changePassword.success': 'Your Password has been changed',
    'changePassword.oldPasswordIncorrect': 'Your old password is incorrect',
    'menu.home': 'Account',
    'menu.admin': 'Admin',
    'menu.trialRegister': 'Trial Registration',
    'menu.reviews': 'Reviews',
    'menu.trials': 'Trials / Digital Readout Tests',
    'menu.users': 'Users',
    'menu.institute': 'Institute',
    'menu.logout': 'Logout',
    'menu.login': 'Login',
    'menu.surveys': 'Surveys',
    'menu.mySurveys': 'Surveys',
    'menu.submissions': 'Submissions',
    'menu.enrollments': 'Enrollments & Invoices',
    'menu.certificates': 'Certificates',
    'menu.quipBioMarker': 'QuIP Biomarker Portals',
    'menu.pdl1Portal': 'PD-L1 Portal',
    'menu.lungenkarzinomPortal': 'Lungenkarzinom Portal',
    'menu.mammakarzinomPortal': 'Mammakarzinom Portal',
    'menu.msiDmmrPortal': 'MSI/dMMR Portal',
    'menu.fgfrPortal': 'FGFR Portal',
    'menu.hrdPortal': 'HRD Portal',
    'passwordRequest.heading': 'Password Request',
    'passwordRequest.buttonLabel': 'Submit Request',
    'passwordRequest.goToLogin': 'Go to login',
    'legend.title': 'Legend',
    'legend.correct': 'Correct Answer',
    'legend.acceptable': 'Acceptable Answer',
    'legend.false': 'Wrong Answer',
    'legend.review': 'Reviewed Answer',
    'legend.dismissed': 'Question irrelevant to this case',
    'legendAggergation.reviewCount': 'Participants with Review Points',
    'legendAggergation.nonReviewCount': 'Participants without Review Points',
    'legendAggergation.rightAnswers': 'Bold answers: Correct answers',
    'login.expired': 'Your access has expired, please login again',
    'login.signupLabel': 'Register new Account?',
    'login.signupLink': 'Sign-Up Now!',
    'login.forgotPasswordLabel': 'Forgot your Password?',
    'login.requestPasswordLink': 'Request a new Password',
    'login.tryAgain': 'Try again',
    'login.invalidCredentials': 'The credentials entered for {email} is wrong.',
    'login.generalloginerror': 'The credentials are not valid',
    'login.valueMissing': 'The value must be set',
    'login.emailNotActivated': 'The email enetered ({email}) has not been verified. Please check your inbox.',
    'login.userdoesnotexist': 'The user entered ({email}) does not exist.',
    'login.usernotactivate': 'The user {email} has not been activated. Please contact administrator',
    'login.internetExplorerWarning': 'Internet Explorer is not supported. Please use Google chrome for best experience.',
    'login.switchToGermany': 'Please switch to the German region of QuIP from the top right corner.',
    'login.switchToInternational': 'Please switch to the International region of QuIP from the top right corner',
    'login.qccTitle': 'QuIP Customer Center',
    'login.qccDescription': 'Log in to the new QuIP Customer Center (QCC) to manage your user account, your organization, and your departments, as well as to access the QuIP Shop in order to register for proficiency tests.',
    'login.qccButton': 'Open QuIP Customer Center',
    'login.or': 'OR',
    'resetPassword.passwordsDoNotMatch': 'Passwords do not match',
    'resetPassword.heading': 'Enter a new Password',
    'resetPassword.passwordLabel': 'Password',
    'resetPassword.passwordConfirmLabel': 'Confirm Password',
    'resetPassword.buttonLabel': 'Reset',
    'resetPassword.success': 'Your password has been changed',
    'resetPassword.emailError': 'We can\'t find a user for this E-Mail',
    'resetPassword.resetEmailSend': 'We\'ve send you an E-Mail to reset your password',
    'registration.required': 'Required',
    'registration.headline': 'Registration',
    'registration.noValidVat': 'Please enter a valid VAT ID (e.g: {example} for {country})',
    'registration.instituteInformationHeading': 'Institute and Delivery Address for Test set Shipment',
    'registration.instituteName': 'Name of Institute',
    'registration.instituteNameWithLeadName': 'Name of Institute',
    'registration.hospitalName': 'Name of Hospital',
    'registration.instituteCity': 'City',
    'registration.instituteStreet': 'Street',
    'registration.instituteHousenumber': 'House Number',
    'registration.instituteAdditionalAddress': 'Address suffix (building, house, room, floor, entrance)',
    'registration.instituteZip': 'Zip',
    'registration.instituteCountry': 'Country',
    'registration.userCountry': 'Country',
    'registration.instituteID': 'Institute ID',
    'registration.instituteTaxID': 'Tax ID',
    'registration.instituteComments': 'Additional comments',
    'registration.instituteEmail': 'Institute E-Mail',
    'registration.instituteFax': 'Institute Fax. No.',
    'registration.institutePhone': 'Institute Tel. No.',
    'registration.invoiceName': 'Name of Institute',
    'registration.invoiceCity': 'City',
    'registration.invoiceStreet': 'Street',
    'registration.invoiceHousenumber': 'House Number',
    'registration.invoiceZip': 'Zip',
    'registration.invoiceCountry': 'Country',
    'registration.invoiceNote': '* After registration you can add an order number to each trial invoice if needed.',
    'registration.certificationName': 'Name of Institute',
    'registration.certificationCity': 'City',
    'registration.certificationStreet': 'Street',
    'registration.certificationHousenumber': 'Housenumber',
    'registration.certificationZip': 'Zip',
    'registration.certificationCountry': 'Country',
    'registration.requiredMessage': 'Please fill all required fields marked with a *',
    'registration.invoiceInformationHeading': 'Institute Invoice Address (if different from above)',
    'registration.userGender': 'Title',
    'registration.userTitle.phd': 'Phd.',
    'registration.userTitle.prof': 'Prof.',
    'registration.userTitle': 'Academic title',
    'registration.personalInformationHeading': 'Information about your Person',
    'registration.userFirstName': 'First Name',
    'registration.userLastName': 'Last Name',
    'registration.email': 'Email',
    'registration.userPosition': 'Your position within the Institute',
    'registration.userPositionEmployee': 'Employee',
    'registration.userPositionDirector': 'Head of Institute',
    'registration.userCommLanguage': 'Language for Emails',
    'registration.userCommLanguageGerman': 'German',
    'registration.userCommLanguageEnglish': 'English',
    'registration.userEmail': 'E-Mail',
    'registration.userPassword': 'Password',
    'registration.userPasswordConfirm': 'Password Confirmation',
    'registration.emailAlreadyExists': 'This email address has already been registered',
    'registration.agbAccept': 'Please accept the terms and conditions',
    'registration.userAGBAcceptLabel': 'I accept the terms and conditions',
    'registration.noEmptyField': 'Field cannot be empty',
    'registration.noValidMail': 'Not a valid email address',
    'registration.noValidZip': 'Please enter characters of [0-9][A-Z][a-z][_.-/ ] from 2 to 10 characters only',
    'registration.noSpaceCharacter': 'Blank spaces are not allowed',
    'registration.overview': 'Overview',
    'registration.submit': 'Submit',
    'registration.patientCare': 'Patient care organization (not a company) ',
    'registration.isCompany': 'Company',
    'registration.passwordsNotMatch': 'passwords do not match',
    'registration.activationSuccessful': 'Your Registration has been activated',
    'registration.activationFailure': 'An error occurred during your activation',
    'registration.genericActivationFailure': 'An unknown error occurred during activation. Please contact us via: ringversuche@quip.eu',
    'registration.newsletterOptIn': 'Yes, send me the promotional newsletters',
    'registration.afterSubmitText': 'After submitting this form you will receive an e-mail containing an activation link. Please follow the steps as described in this e-mail to complete registration.',
    'registration.requiredFieldsText': 'Fields marked with a * are required fields.',
    'registration.aboutInvoiceAddress': 'This address is optional. If you skip this address we will use the address from step 1.',
    'registration.patientCareDescription': 'Patient care facilities are institutes for pathology which are directly involved in patient care/diagnostics. These are given priority in the allocation of EQA samples.',
    'registration.aboutDeliveryAddress': 'This address will be used as delivery address (deliveries to post office boxes are not possible)',
    'registration.outdatedToken': 'The activation link is outdated. We will send you a new one. Please check your inbox',
    'registration.doubleConfirmation': 'The account is already activated - Please login',
    'registration.clearanceHandlerHeading': 'Please provide the name and the contact information of the person in charge of handling customs and logistic matters:',
    'registration.info.custom': 'Custom Clearance Information',
    'registration.info.certificate': 'Certificate Address Information',
    'registration.info.invoice': 'Invoice Address Information',
    'registration.customClearanceUser': 'Name',
    'registration.customClearanceContact': 'Phone number',
    'registration.customClearanceEmail': 'Email',
    'registration.eoriNumber': 'Customs Participant Number (EORI)',
    'registration.invoicedifferent': 'Invoice address is different',
    'registration.certificatedifferent': 'Certificate address is different',
    'registration.selectInstitute': 'Please select your institute',
    'registration.mustMatch': 'Password must match',
    'registration.skipandsubmit': 'Skip and Submit',
    'registration.skipWarning': 'Please note that if you register without an institute, you will be able to use personal products such as digital readout tests from QuIP, but in order to be able to take part in regular EQA schemes, you need to belong to an institute.',
    'account.welcome': 'QuIP Member area',
    'account.customerInformation': 'Your personal data',
    'account.loginMessage': 'You are logged in as',
    'account.enrolledTrials': 'You are enrolled in the following Trials',
    'account.forwardMailDescription': 'You can add 3 additional E-Mail addresses, to which all notifications will be sent',
    'account.logout': 'logout',
    'account.forwardAddressesHeading': 'Notification Email Addresses',
    'account.forwardAddressesHeading.helpTitle': 'Notification Email Addresses Help',
    'account.forwardAddressesHeading.helpText': 'In this section you can add up to 3 recipients which will receive all notifications',
    'account.changeForwardAddress': 'Set Email Address',
    'account.changePasswordLabel': 'Change Password',
    'account.passwordsDoNotMatch': 'Passwords do not match',
    'account.instituteAddress': 'Institute Address',
    'account.certificateAddress': 'Certificate Address',
    'account.invoiceAddress': 'Invoice Address',
    'adminview.headline': 'Administration',
    'adminview.userManagementTab': 'User',
    'adminview.enrollmentsManagementTab': 'Enrollments',
    'adminview.customFieldsManagementTab': 'Custom Fields',
    'adminview.trialManagementTab': 'Trials',
    'admindetails.unverifiedUsers': 'Following users require verification',
    'admindetails.declareReviewers': 'Manage Reviewers',
    'admindetails.resetEmailAdress': 'Reset Email',
    'admindetails.resetEmailButton': 'Change Email Address',
    'admindetails.resetEmailNewEmailHint': 'Enter new E-Mail address',
    'admindetails.selectRegistrationData': 'Use institute data during registration',
    'admindetails.existingInstituteData': 'Use an existing institute',
    'admindetails.generalActions': 'General',
    'admindetails.exportAllUsers': 'User Export',
    'admindetails.exportAllInstitutes': 'Institute Export',
    'admindetails.masterBookingListHeadline': 'Master Booking List',
    'admindetails.masterBookingListButton': 'Create Booking List',
    'admindetails.masterBookingStartDate': 'Start Date',
    'admindetails.masterBookingEndDate': 'End Date',
    'admindetails.usersManagement': 'User Management',
    'trials.trialCode': 'Code',
    'trials.trialYear': 'Year',
    'trials.trialName': 'Name of Trial',
    'trials.status': 'Status',
    'trials.enrollmentstatus': 'Enrollment Status',
    'trials.startDate': 'Trial Start Date',
    'trials.endDate': 'Trial End Date',
    'trials.endDateUntil': 'Delivery until',
    'trials.registrationStartDate': 'Registration Start Date',
    'trials.registrationEndDate': 'Registration End Date',
    'trials.newPostSubmissionDate': 'Post Submission End Date',
    'trials.numParticipants': 'Number of participants',
    'trials.numSamples': 'Number of samples',
    'trials.price': 'Price',
    'trials.enroll': 'Enroll to trial',
    'trials.enroller': 'Enroller',
    'trials.tag': 'Method/Type',
    'trials.samplesDelivered': 'Deliveries',
    'trials.enrollmentRole': 'Enrollment\'s Role',
    'trials.changeEnrollmentRole': 'Change Enrollment Role',
    'trialConfirmation.headline': 'Continue to Billing Information',
    'trialConfirmation.confirm': 'Sign Up',
    'trialConfirmation.cancel': 'Cancel',
    'trials.searchHeading': 'Search (by trial name)',
    'trials.searchHeading.helpTitle': 'Trial Search Help',
    'trials.searchHeading.helpText': 'Search for proficiency tests that are currently open for registration',
    'trials.searchHint': 'Search Term',
    'trials.searchButtonLabel': 'Search',
    'trials.resetButtonLabel': 'Reset',
    'trials.manual': 'Instructions',
    'trials.rowsPerPageLabel': 'Trials per page',
    'trials.noTrialsFound': 'No trials found',
    'trials.showDeactivateTrials': 'Show archived trials',
    'trials.showCompletedTrials': 'Show completed trials',
    'trials.trialIsFull': 'Registration only via Waitinglist',
    'trials.registraionClosed': 'Registration for this trial is not open yet.',
    'trials.registrationEnd': 'Registration for this trial has been ended',
    'trials.alreadyEnrolled': 'User already registered for the trial',
    'trials.noGermanInstitute': 'Institutes from Germany are unfortunately not allowed to enroll to this trial',
    'trials.instituteUnapproved': 'Your institute is pending for approval. Please try again later.',
    'trialdetails.header': 'Trial Details',
    'trialdetails.surname': 'Surname',
    'trialdetails.firstname': 'First Name',
    'trialdetails.title': 'Title',
    'trialdetails.city': 'City',
    'trialdetails.attendeeInstitute': 'Institute',
    'trialdetails.patientCare': 'Patient Care',
    'trialdetails.status': 'Status',
    'trialdetails.invoiced': 'Invoiced',
    'trialdetails.statusApproved': 'approved',
    'trialdetails.statusApplied': 'applied',
    'trialdetails.statusRejected': 'rejected',
    'trialdetails.statusCancelled': 'cancelled',
    'trialdetails.actionApprove': 'Approve Enrollment',
    'trialdetails.actionReject': 'Reject Enrollment',
    'trialdetails.cancelInvoice': 'Cancel Invoice',
    'trialdetails.downloadInvoice': 'Download Invoice',
    'trialdetails.downloadCancelledInvoice': 'Download Cancelled Invoice',
    'trialdetails.actionCancel': 'Cancel Enrollment',
    'trialdetails.showCertificate': 'Show Certificate',
    'trialdetails.approveCertificate': 'Approve Certificate',
    'trialdetails.uploadCertificate': 'Upload Certificate',
    'trialdetails.actionShowSubmission': 'Show Submission',
    'trialdetails.unfinalizedButtonDisableTooltip': 'Either the user has not finalized their submission or the trial has ended',
    'trialdetails.trialIsDeactivated': 'Trial is deactivated, no changes possible',
    'trialdetails.certificatedIsApproved': 'Certificate is approved, no changes possible',
    'trialdetails.enrollmentCancelled': 'Enrollment is not approved, no changes possible',
    'trialdetails.allowPostResubmit': 'Allow Revision',
    'trialdetails.recreateCertificate': 'Recreate Certificate',
    'trialdetails.recreateCertificateSuccess': 'Certificate successfully recreated',
    'trialdetails.showReview': 'Show Review',
    'trialdetails.evaluate': 'Apply Groundtruth',
    'trialdetails.releaseEvaluation': 'Release Evaluation',
    'trialdetails.unapproveCertificate': 'Unapprove Certificate',
    'trialdetails.unapproveButton': 'Unapprove',
    'trialdetails.unapproveCertificateWarning': 'Are you really sure you want to unapprove the certificate. This action will be logged and can not be undone afterwards!',
    'trialdetails.unapproveReasonTextfield': 'Please give a reason or a reference to a document describing the background of this action.',
    'trialdetails.sectionReview': 'Section comments',
    'trialdetails.sectionOverview': 'General comments',
    'trialdetails.textBlockReviewTitle': 'Section Review-comments',
    'trialdetails.reviewTitle': 'Review Results',
    'trialdetails.surveyTitle': 'Surveys Results',
    'trialdetails.enrollDate': 'Enroll Date',
    'trialdetails.sampleset': 'Set Number',
    'trialdetails.gtgroup': 'Ground Truth Group',
    'trialdetails.downloadCertBundle': 'Download Certificate Bundle',
    'trialdetails.unknownEnrollmentStatus': 'unknown',
    'trialdetails.submissionStatus': 'Submission status',
    'trialdetails.notstarted': 'Not started',
    'trialdetails.submissionfinalizedTrue': 'Finalised',
    'trialdetails.submissionfinalizedFalse': 'In Progress',
    'trialdetails.failRate': 'Failure rate',
    'trialdetails.postResubmitMessage': 'Select a new closing date for the submission of {trialCode} by {title} {lastName}',
    'trialdetails.confirmCancelInvoice': 'Are you sure you want to cancel the invoice?',
    'trialdetails.confirmCancelEnrollment': 'Are you sure you want to cancel the enrollment?',
    'trialdetails.postResubmitWarning': 'Submission has been finalised. Proceeding with post resubmission will reset the finalisation of this participant\'s submission',
    'trialdetails.postResubmitTrialNotEnd': 'Trial has not ended yet. Please select a date after the trial end date.',
    'trialdetails.pricedescription': 'plus VAT and shipping costs (if applicable)',
    'trialdetails.trialStatus': 'Trial Status',
    'trialSearch.typeSelectHeading': 'Type',
    'trialSearch.yearSelectHeading': 'Year',
    'trialSetup.trialsettingHeadline': 'Trial Settings',
    'trialSetup.registrationHeadline': 'Registration Settings',
    'trialSetup.certificateHeadline': 'Certificate Settings',
    'trialSetup.reviewHeadline': 'Review Settings (Experimental)',
    'trialSetup.archiveHeadline': 'Archive This Trial',
    'trialSetup.successTemplate': 'Success Certificate Template',
    'trialSetup.failTemplate': 'Participation Certificate Template',
    'trialSetup.trialAvailability': 'Trial Availablility',
    'trialSetup.trialIsInternationl': 'International',
    'trialSetup.availableForBoth': 'Available for both on quailityinpathology.com and quip.eu (invoice and certificates will be in English)',
    'trialSetup.isDRT': 'Digital Readout Test',
    'trialSetup.makeAsDRT': 'Make this trial DRT',
    'trialSetup.survey': 'Survey: {trialName}',
    'trialSetup.publish': 'Confirm and Publish',
    'trialSetup.setInstitute': 'Set',
    'trialSetup.changeInstitute': 'Change',
    'trialSetup.removeInstitute': 'Remove',
    'trialSetup.instituteNameColumn': 'Name',
    'trialSetup.instituteCityColumn': 'City',
    'trialSetup.chooseInstitute': 'Select',
    'trialSetup.customFields': 'Custom Field',
    'trialSetup.fieldEmpty': 'Field can not be empty',
    'trialSetup.dateMustBeBeforeStartDate': 'Date must be before period of investigation.',
    'trialSetup.dateMustBeBeforeRegistrationStartDate': 'Date must be before registration start date.',
    'trialSetup.dateMustBeAfterStartDate': 'Date must be after period of investigation start date.',
    'trialSelector.createSurveyButton': 'Create Survey',
    'trialSetup.hintFreeText1': 'Antikoerper',
    'trialSetup.hintFreeText2': 'Automat',
    'trialSetup.trialName': 'Trial name',
    'trialSetup.trialCode': 'Trial code',
    'trialSetup.startDate': 'Start Date',
    'trialSetup.endDate': 'End Date',
    'trialSetup.registrationStartDate': 'Registration Start Date',
    'trialSetup.registrationEndDate': 'Registration End Date',
    'trialSetup.amountParticipants': 'Number of participants',
    'trialSetup.price': 'Price in Euro',
    'trialSetup.numberOfSamples': 'Number of samples',
    'trialSetup.leadOnCertificate': 'Lead as written on certificate',
    'trialSetup.nameOnCertificate': 'Name as written on certificate',
    'trialSetup.label': 'Add Trial Label',
    'trialSetup.parentTrialId': 'Name of Parent Trial',
    'trialSetup.costCenter': 'Cost Center',
    'trialSetup.trialType': 'Trial Type',
    'trialSetup.trialCategory': 'Registration Method',
    'trialSetup.textblockComments': 'Text Block Comments (please upload comments file in Review page)',
    'trialSetup.textblockCommentTitle': 'Text Block Comments',
    'trialSetup.educativeComments': 'Educative Review (staining review)',
    'trialSetup.reviewCategory': 'Review Category',
    'trialSetup.trialTypePathology': 'Pathology',
    'trialSetup.trialTypeNeuropathology': 'Neuropathology',
    'trialSetup.datesCanNotBeTheSame': 'Start and Enddate can not be the same',
    'trialSetup.deactivateTrial': 'Archive this proficiency test',
    'trialSetup.surveyHeadline': 'Survey Settings',
    'trialSetup.surveySelectionLabel': 'Survey Version',
    'trialSetup.reviewSelectionLabel': 'Review Category',
    'trialSetup.excludeShippingFee': 'Exclude Shipping Fee',
    'trialSetup.excludeShippingFeeText': 'All shipping fee will be €0.00',
    'trialSetup.excludeAdminFee': 'Exclude Administrative Fee',
    'trialSetup.excludeAdminFeeText': 'All administrative fee will be €0.00',
    'trialSetup.accredited': 'Accredited',
    'trialSetup.notAccredited': 'Not Accredited',
    'trialSetup.accreditedMessage': 'Is the trial accredited?',
    'trialSetup.accreditedMessage2': 'Is accredited',
    'trials.accreditedStatus': 'Accreditation Status DIN EN ISO/IEC 17043:2023',
    'payment.heading': 'Payment',
    'payment.payoneUrlGenerationError': 'Error during payment request. Please contact us at ringversuche@quip.eu',
    'payment.creditCard': 'Credit Card',
    'payment.bankTransfer': 'Bank Transfer',
    'payment.invoice': 'Invoice',
    'payment.debitPayment': 'Debit Payment',
    'payment.method': 'Payment Method',
    'payment.redirectMessage': 'You will be redirected to our payment partner, if your\'re not redirected in some seconds click this',
    'payment.redirectMessageInvoice': 'Payment via invoice successfully created. You will be directed to the invoice generator. Click link if you are not redirected for some time. ',
    'payment.elvMandateText': 'The debit mandate is valid just once for this payment.',
    'payment.invoiceConfirmationTextRec': 'Please generate the invoice here now and then transfer the amount to the specified account.',
    'payment.invoiceConfirmationText': 'The payment was appointed successfully.',
    'payment.redirectLink': 'link',
    'payment.pending': 'The payment is still pending please check back later',
    'payment.proceedToPayment': 'Proceed To Payment',
    'payment.success': 'Payment appointed, you\'ll be notified once we received the payment',
    'payment.failed': 'Payment failed please contact office@quip.eu',
    'payment.description': 'Payment is by invoice. After you click "Proceed to payment", your invoice will be created and you can confirm to complete registration.',
    'payment.aboutOrderNumber': 'We need your Buyer Reference to provide you with an E-Invoice. The Buyer Reference is a unique number given to your institution for invoices. Please enter the Buyer Reference in the textbox and apply the number to your invoice by clicking on the button „APPLY BUYER REFERENCE“. Your financial department may give you more information on your Buyer Reference. You may add the Buyer Reference later and then download the E-Invoice.',
    'payment.inProcess': 'Payment in process. Please try downloading invoice in few minutes',
    'payment.enrollmentPending': 'Your enrollment is pending for authorization. Until then we could not process any payment yet.',
    'help.dialogStep': 'Help',
    'help.complaint': 'Give Feedback',
    'help.complaintStep': 'Feedback',
    'help.complaintFormHint': 'Enter your feedback here.',
    'help.complaintSend': 'Send Feedback',
    'help.complaintSent': 'Feedback Sent',
    'enrollmentsmanager.headline': 'Pending Enrollments',
    'enrollmentsmanager.confirmationButtonLabel': 'Resolve',
    'enrollmentsmanager.confirmationTitle': 'Please choose to proceed',
    'enrollmentsmanager.confirmationCancel': 'Cancel',
    'enrollmentsmanager.confirmationProceed': 'OK',
    'enrollmentsmanager.confirmationText': 'Are you sure?',
    'enrollmentsmanager.goToSurvey': 'Survey',
    'enrollmentsmanager.detailedEvaluationPrintButton': 'Print',
    'enrollmentsmanager.detailedEvaluationButton': 'Evaluation',
    'enrollmentsmanager.detailedEvaluation': 'Evaluation for trial {trial}',
    'enrollmentsmanager.overallEvaluation': 'Overall Evaluation',
    'enrollmentsmanager.invoiceDialogOpenButton': 'Invoice',
    'enrollmentsmanager.invoiceDialogTitle': 'Invoice',
    'enrollmentsmanager.downloadInvoiceButton': 'Download Invoice',
    'enrollmentsmanager.downloadEInvoiceButton': 'Download E-Invoice',
    'enrollmentsmanager.orderNumberTextFieldLabel': 'Buyer reference',
    'enrollmentsmanager.orderNumberExistsTextFieldLabel': 'Previously entered order number.',
    'enrollmentsmanager.orderNumberWarningText': 'Are you sure you do not want to assign an order number to your invoice? You will not be able to assign one later.',
    'enrollmentsmanager.cancelledInvoices': 'Cancelled Invoices',
    'enrollmentsmanager.trialCancelledHeading': 'Trial cancelled',
    'enrollmentsmanager.trialCancellationNote': 'Your enrollment of this Trial was cancelled.',
    'enrollmentsmanager.passedSubmissions': 'Passed Submissions',
    'enrollmentsmanager.passedSubmissionsSection': 'Passed Submissions (section)',
    'enrollmentsmanager.quotaPassedSubmissions': 'Success Rate',
    'enrollmentsmanager.pointsAchieved': 'Points achieved',
    'enrollmentsmanager.pointsAfterReview': 'Points after review',
    'enrollmentsmanager.pointsAchievedWithReview': 'Review Score',
    'enrollmentsmanager.faerbungAdditionalInfo': ' (Stain + Review)',
    'enrollmentsmanager.sectionScore': 'Section score',
    'enrollmentsmanager.totalScore': 'Total score',
    'enrollmentsmanager.reviewSubmission': 'Review Submission',
    'enrollmentsmanager.setInvoiceNumber': 'Apply Buyer Reference',
    'enrollmentsmanager.invoiceNumberSet': 'Invoice number has been set',
    'enrollmentsmanager.postResubmitExpired': 'Your revision submission has expired',
    'enrollmentview.pendingapproval': 'Enrollment is pending for approval',
    'enrollmentview.trialhasnotstarted': 'Trial has not started or has ended',
    'trialmanagement.downloadInvoices': 'Invoice Bundle',
    'trialmanagement.headline': 'Trial Management',
    'trialmanagement.newTrialButton': 'New Trial',
    'trialmanagement.editTrialButton': 'Edit Trial',
    'trialmanagement.saveChangesButton': 'Save Changes',
    'trialmanagement.uploadManual': 'Upload Manual',
    'trialmanagement.createParticipantsList': 'List of Participants',
    'trialmanagement.uploadDeliveryListButton': 'Upload Delivery List',
    'trialmanagement.uploadDeliveryListFailed': 'Upload Delivery List Failed',
    'trialmanagement.uploadButton': 'Upload',
    'trialmanagement.browseButton': 'Choose',
    'trialmanagement.selectedFiles': 'Selected Files',
    'trialmanagement.fileUploadDialogTitle': 'Upload a Trial Manual',
    'trialmanagement.fileUploadDialogDescription': 'Please choose a file from your computer and click upload',
    'trialmanagement.editGroundTruth': 'Edit Ground Truth',
    'trialmanagement.details': 'Trial Details',
    'trialmanagement.goToSurvey': 'Show Survey',
    'trialmanagement.createBookingsList': 'Create Bookingslist',
    'trialmanagement.createCertificates': 'Create Certificates',
    'trialmanagement.fetchingEnrollments': 'Fetching enrollments',
    'trialmanagement.certificateProcess': 'Creating certificates ... ',
    'trialmanagement.certificateProcessCompleted': 'Certificate creation process completed',
    'trialmanagement.notifyCancelCertificate': 'Please cancel all certificates for the proficiency tests first.',
    'trialmanagement.exportSubmissions': 'Export Submissions',
    'trialmanagement.exportEvaluations': 'Export Evaluations',
    'trialmanagement.surveyUnavailable': 'Survey unavailble',
    'trialmanagement.surveyEditorUnavailable': 'This feature is avaialble not avaiable to previous old surveys',
    'trialmanagement.createEditSurvey': 'Create/Edit Survyey',
    'trialmanagement.exitBeforeSaving': 'Are you sure you want to leave before savings your changes?',
    'trialmanagement.excelImportMissingKundennummer': 'The column named "kundenummer" not found. Please check for spelling mistakes.',
    'trialmanagement.excelImportMissingColumn': 'No column "setnummer" or "groundtruth" found. Please set either one or both columns.',
    'trialmanagement.emptyKundennummer': 'Empty QID found at row {rowNumber}',
    'trialmanagement.uploadTerms': 'Upload Terms',
    'groundtruthview.unapproveCertificate': 'Please first unapprove all certificates for the proficiency test in order to process the ground truth.',
    'groundtruthview.minimalScore': 'Minimal overall score',
    'groundtruthview.evaluationFormulaHeadline': 'Evaluation Formula section',
    'groundtruthview.evaluationFormulaPlaceholder': 'Eg. q1 * (q1 + q2 + q3)',
    'groundtruthview.evaluationFormula': 'Formula (optional',
    'groundtruthview.submittedGroundTruth': 'Submit was successful',
    'groundtruthview.minimumScoreSection': 'Minimum score for section',
    'groundtruthview.considerInGroundTruth': 'Part of Groundtruth calculation',
    'groundtruthview.considerOptionalSection': 'Optional Section (scores will be evaluated but will not contribute to the overall pass or fail of trial)',
    'groundtruthview.evaluationInReview': ' - Evaluation via the reviewer tool - ',
    'groundtruthview.passedPercentage': 'Passed score in %',
    'groundtruthview.maximumScore': 'Maximum score',
    'groundtruthview.minimumScore': 'Minimum score to pass',
    'groundtruthview.mainSettings': 'Ground Truth settings',
    'groundtruthview.manageGroundtruth': 'Manage Ground Truths',
    'groundtruthview.deleteConfirm': 'Are you sure you want to delete this groundtruth?',
    'groundtruthview.selectDelete': 'Please select the Groundtruth from the dropdown list to delete',
    'groundtruthview.optionalSectionEnabled': 'Optional Sections are enabled and user can opt-out of participation in each section. Please set the overall points according to your needs',
    'groundtruth.title': 'Confrim Delete Ground-Truth',
    'groundtruth.message': 'Are you sure you want to delete this Ground-Truth?',
    'groundtruthmultiplechoice.unitymessage': 'Unity score will only count every points per case when participants answers ALL of the options correctly',
    'editTrial.headline': 'Edit Trial',
    'faerbung.criteria': 'Criteria',
    'faerbung.sensitivity': 'Sensitivity / Reaction strength',
    'faerbung.specifity': 'Specificity, sample quality + tissue preservation',
    'feedback.headline': 'Successfully submitted:',
    'feedback.starRatingDescription': 'Please select the amount of stars to rate the Trial',
    'feedback.textFieldHeading': 'Your Comment',
    'feedback.submitRating': 'Submit Rating',
    'feedback.backHome': 'Back Home',
    'feedback.titleIntro': 'Anonymous Feedback for trial: {trialName} (No information on proficiency test samples)',
    'feedback.note': 'Your feedback will be evaluated anonymously. If you would like our feedback, please contact us directly at ',
    'mysurvey.sampleId': 'Sample Id',
    'mysurvey.emptySectionWarning': 'Empty sections detected',
    'mysurvey.emptySectionWarningText': 'The surveys consists of multiple sections, which can be accesses via the the tabs on top of the survey. You did not give answers to at least on of the provided sections.',
    'mysurvey.emptySectionWarningQuestion': 'Are you willing to proceed anyways?',
    'containerdownload.message': 'Click here do download the requested file',
    'containerdownload.download': 'download',
    'containerdownload.cancel': 'cancel',
    'trialtable.upcomingStatus': 'upcoming',
    'trialtable.ongoingStatus': 'ongoing',
    'trialtable.registrationUpcomingStatus': 'registration upcoming',
    'trialtable.registrationStatus': 'registration',
    'trialtable.pendingStatus': 'evaluation pending',
    'trialtable.finished': ' completed',
    'trialtable.waitingForStart': 'registration complete. waiting for trial start',
    'trialtable.unknownStatus': 'unknown status',
    'userDetails.userDataHeading': 'Account Data',
    'userDetails.userDataHeading.helpTitle': 'Account Data Help',
    'userDetails.userDataHeading.helpText': 'In this section you can review and change your personal data.',
    'userDetails.title': 'Title',
    'userDetails.firstname': 'First Name',
    'userDetails.surname': 'Last Name',
    'userDetails.position': 'Position',
    'userDetails.realm': 'Realm',
    'userDetails.activated': 'Active',
    'userDetails.username': 'Username',
    'userDetails.email': 'E-Mail',
    'userDetails.emailVerified': 'E-Mail Verified',
    'userDetails.editUser': 'Edit User',
    'userDetails.notificationOptOut': 'Disable E-Mail Notifications',
    'submissions.headline': 'Enrollments',
    'submissions.headline.helpTitle': 'Enrollments Help',
    'submissions.headline.helpText': 'In this section you can review all your enrollments and start a survey.',
    'submission.saved': 'saved',
    'submission.saving': 'saving...',
    'submission.incomplete': 'Please fill in the text, otherwise your entries will not be saved',
    'submission.saveFailedEndDate': 'Submission was not finalized. The trial has ended. Please contact administrator',
    'instituteView.headline': 'Institute',
    'instituteView.instituteBrief': 'Summary',
    'instituteView.instituteDataHeading': 'Delivery Address/Invoice Address/Certificate Address',
    'instituteView.instituteDataHeading.helpTitle': 'Institute Data Help',
    'instituteView.instituteDataHeading.helpText': 'In this section you can review and change institute, invoice and certification details.',
    'instituteView.editInstitute': 'Edit Delivery Address/Invoice Address/Certification Address',
    'instituteView.registerNewInstitute': 'Register Institute',
    'instituteView.noInstituteAssigned': 'Your account has not been assigned to an institute yet by our administrator. Please try again later.',
    'instituteEditDialog.edit': 'Edit Institute Data',
    'instituteEditDialog.instituteDataHeading': 'Institute and Delivery Address for Test set Shipment',
    'instituteEditDialog.invoiceDataHeading': 'Invoice Details (optional)',
    'instituteEditDialog.certificationDataHeading': 'Certification Details (optional)',
    'certificatesView.getCertificate': 'Certificate',
    'certificatesView.createCertificate': 'Create',
    'certificatesView.certificateAvailable': 'Certificate available',
    'certificatesView.submissionMissing': 'No Submission',
    'certificatesView.groundTruthMissing': 'Evaluating',
    'certificatesView.unknownState': 'Unknown',
    'certificatesView.certificateIssued': 'Certificate issued',
    'certificatesView.pendingCertificates': 'Recent Certificates',
    'certificatesView.pendingCertificates.helpTitle': 'Recent Certificates Help',
    'certificatesView.pendingCertificates.helpText': 'In this section you can create a certificate for passed enrollments.',
    'certificatesView.acquiredCertificates': 'Acquired Certificates',
    'certificatesView.acquiredCertificates.helpTitle': 'Acquired Certificates Help',
    'certificatesView.blockCertificateMessage': 'Your certificate is ready but pending approval from QuIP. Please contact QuIP for further information.',
    'certificate.uploadCertificate': 'Upload Certificate',
    'certificate.uploadWarning': 'Already existing certificate will be removed',
    'customfieldeditor.fieldSetName': 'Name of the template',
    'customfieldeditor.newOption': 'Enter new option',
    'customfieldeditor.addOptionButton': 'Add option',
    'customfieldeditor.changeOptionButton': 'Change',
    'customfieldeditor.question': 'What is the question',
    'customfieldeditor.headline': 'Headline of the combo box',
    'customfieldeditor.editHeadline': 'Edit Custom Field',
    'customfieldeditor.previewHeadline': 'Preview Custom Field',
    'customfieldeditor.saveAsHeadline': 'Save as template',
    'customfieldeditor.saveButton': 'Save',
    'customfieldeditor.resetButton': 'New',
    'configurecustomfields.availableSetsHeadline': 'Available Templates',
    'configurecustomfields.configuredSets': 'Configured Custom Fields',
    'configurecustomfields.addButton': 'Add',
    'downloadView.downloadNotAvailable': 'This download is not available please contact office@quip.eu for help',
    'survey.generalCommentHeading': 'General Comment',
    'survey.finaliseDialogHeading': 'Finalize Submission',
    'survey.goToIncompleteSection': 'Go to incomplete section',
    'survey.reviewSubmission': 'Review Submission',
    'survey.confirmFinalisationButtonLabel': 'Finalise Trial',
    'survey.cancelSubmitSubmission': 'Close without save',
    'survey.backToEnrollments': 'Back',
    'survey.finalisationWarning': 'You can not do any changes after finalisation. Please review your answers',
    'survey.finalisedNote': 'You finalised this trial',
    'survey.surveyHighlight': 'Questionaire text has been updated, click to check the highlights',
    'survey.saved': 'Submission saved',
    'survey.saveFailed': 'Submission was not saved',
    'survey.finalizedFailed': 'Submission cannot be finalised, please contact admin.',
    'survey.notComplete': 'Please check the questions marked in red and provide an answer. In the case of free text questions, please enter a dash symbol if the question is not applicable.',
    'survey.deleteShareLink': 'Disable Shared Link',
    'survey.participateOptOut': 'Opt out of participation',
    'survey.optOutWarningTitle': 'Opt-out from "{sectionName}"',
    'survey.optOutWarning': 'Are you sure you want to opt-out from this section? All entries you\'ve submitted for this section will be removed when you click confirm. CAUTION: You can undo this by clicking the same checkbox BUT your entries will NOT be restored!',
    'survey.optOut': 'Opt-out from this section',
    'survey.labelOptout': 'Opt-out: ',
    'survey.confirmOptOut': 'Opting out will remove the current submission entries on this section',
    'survey.compulsoryWarn': 'It looks like you have missed one or more compulsory question(s). Please answer all the questions that are compulsory. You may also opt-out if the section allows it to.',
    'survey.submitInfo': 'By clicking on the submit button, you confirm the submission of this survey. Further changes to your answers will not be possible.',
    'survey.methodologicalSelector': 'Methodological Questions',
    'survey.optionalSection': 'This section is not relevant for passing the EQA.',
    'surveyHighlight.oldText': 'Old text was',
    'surveyHighlight.updatedAt': 'Updated at',
    'textblock.uploadTextBlockComments': 'Upload Textblock-comments',
    'trialsenrolled.warningheadline': 'The trial has already enrolled',
    'trialsenrolled.content': 'You have already signed up for this trial {trialName}. For more detailed information, please go to Enrollment and Invoices. Do you wish to continue?',
    'trialsenrolled.contentDRT': 'You have already signed up for this Digital Readout Test {trialName}. For more detailed information, please go to Enrollment and Invoices. Do you wish to continue?',
    'instituteEditDialog.inputMissing': 'Please fill in this field',
    'review.assignedReviewsHeadline': 'Assigned Reviews ({amount})',
    'review.submissionsHeadline': 'Submissions {trial}',
    'review.reviewSubmissionButton': 'Review',
    'review.submissionHeadline': 'Submission of {user}',
    'review.reviewHeadline': 'Your Review',
    'review.submitReviewSubmission': 'Save review',
    'review.cancelReviewSubmission': 'Back',
    'review.justificationHeading': 'Your overall Justification',
    'review.sectionJustificationHeading': 'Your Justification of this section',
    'review.unavailable': 'Either there are no submissions for this trial or the evaluation has not been completed.',
    'review.reviewManagement': 'Manage Reviews',
    'review.methodicalQuestionTitle': 'Methodological Question',
    'review.showOpenQuestions': 'Show Methodological Questions',
    'review.noOpenQuestions': 'No Methodological Questions',
    'review.contextOpenQuestionsSubheadline': 'Section scope: {name}',
    'review.trialOpenQuestionsSubheadline': 'Whole survey scope',
    'review.anonymizeHeader': 'Set number of the submission',
    'review.printAll': 'Print All',
    'review.printSettings': 'Print Settings',
    'review.questionsLayout': 'Questions Layout',
    'review.printHorizontalQuestion': 'Set case numbers horizontally',
    'review.printVerticalQuestion': 'Set case numbers vertically',
    'review.sectionBreak': 'New page per section',
    'review.displayOptions': 'Display Options',
    'review.displayAllQuestions': 'Display all questions',
    'review.displayAnsweredQuestions': 'Display answered questions only',
    'review.notfinalized': 'This submission is not finalized by the user yet',
    'review.faerbungReviewTitle': 'Staining Review',
    'review.sectionCommentHeadline': 'Section Comment',
    'review.surveyCommentHeadline': 'Survey Comment',
    'review.addCommentSection': 'Add comment on this section',
    'review.addCommentSurvey': 'Add comment on this survey',
    'review.title': 'Confrim Delete Review Score',
    'review.submittedAnswer': 'Submitted Answer',
    'review.gtAnswer': 'Reference Value',
    'review.message': 'Are you sure you want to delete this review score?',
    'review.noReview': 'No review points',
    'reviewmanagement.removeAssignment': 'Remove request',
    'reviewmanagement.removeAssignments': 'Remove reviewers from {trial}',
    'reviewmanagement.addAssignments': 'Add reviewers to {trial}',
    'reviewmanagement.selectedReviewer': 'Select reviewer',
    'reviewmanagement.addAssignment': 'Add reviewer',
    'reviewmanagement.multiCommentWarning': 'Comment Data already exists in this trial\'s review. Uploading new data will cause the removal of all the comments in already existing reviews of this trial.',
    'reviewmanagement.passStatus': 'The participant passed with a score of {points}',
    'reviewmanagement.failStatus': 'The participant didn\'t pass with a score of {points}',
    'textblock.uploadSuccess': 'Successfully uploaded',
    'review.openQuestionsHeadline': 'Open Questions',
    'review.minScoreHeadline': 'Minimum Required Points',
    'review.obtainedScoreHeadline': 'Obtained Points',
    'review.reviewScoreHeadline': 'Points After Review',
    'review.sectionStainingReview': 'Section Staining Review: ',
    'review.surveyStainingReview': 'Overall Staining Review: ',
    'review.resetReview': 'Reset Review Score',
    'review.obtainedScoreDialog': 'Obtained Points',
    'review.reviewScoreDialog': 'Review Points',
    'review.sectionStatus': 'Section Status: ',
    'review.overallStatus': 'Overall Status: ',
    'review.questionHeadline': 'Questions',
    'evaluationdialog.reviewsection': 'Review Comments',
    'evaluationdialog.noSubmissions': 'No submissions exist for this enrollment',
    'evaluationdialog.optionalSection': 'This is an Optional Section and its marks will have no influence on the overall survey score or result',
    'declareReviewers.addReviewerButton': 'Assign reviewer',
    'declareReviewers.removeReviewerButton': 'remove Reviwer',
    'reviewdialog.headline': 'Review',
    'admindetails.geocodeUnlocatedInstitutesHeadline': 'Institutelocation on map',
    'admindetails.geocodeUnlocatedInstitutesButton': 'Add missing locations',
    'createeditsurveyview.newsection': '+ Section',
    'createeditsurveyview.settings': 'Settings',
    'createeditsurveyview.trialHasStaredMessage': 'The trial has started. Editing this survey is limited',
    'createeditsurveyview.resetGroundTruth': 'The survey has been modified. Saving will cause last entered Ground Truth to be reset',
    'sectioneditor.sectionheadline': 'Section Headline',
    'sectioneditor.numofcases': 'Number of cases',
    'questionscontainer.addquestion': '+ Question',
    'questionscontainer.addcontextquestion': '+ Context Question',
    'questiontypelist.title': 'Choose a quesion type',
    'questionlist.options': ' options',
    'questioneditor.questiontext': 'Question text',
    'questioneditor.required': ' Mandatory question',
    'questioneditor.addnewoption': '+ Option',
    'questioneditor.enabledetailquestion': 'Enable detail question',
    'questioneditor.clicktoeditdetailquestion': 'Click to edit detail question',
    'questioneditor.placeholdertext': 'Enter placeholder',
    'questionEditor.hideAggregation': 'Hide from Submission Aggregation',
    'questionEditor.hideAggregationTooltip': 'Question hidden from evaluation',
    'questionEditor.technicallyNotEvaluable': 'Technically not evaluable',
    'questionEditor.enableTNA': 'Activate "Technically not evaluable"',
    'questionEditor.changeType': 'Change Type',
    'surveysettings.numberofsections.1': 'This survey contains ',
    'surveysettings.numberofsections.2': ' section(s)',
    'surveysettings.setOptionalSurveys': 'Set survey sections optional for submission',
    'sectionSettings.optionalSection': 'Section is not relevant for passing the EQA',
    'sectionSettings.optOut': 'Enable opt-out',
    'surveyDuplicate.copySurvey': 'Copy Survey',
    'surveyDuplicate.replicateSurvey': 'Replicate questionnaire from existing questionnaire',
    'voucher.redeemVoucher': 'Redeem Voucher',
    'voucher.couponCode': 'Registration Code',
    'voucher.techPdf': 'Technical information and instructions',
    'voucher.proceedLogin': 'In order to proceed, please login to your personal account or register a new user account',
    'voucher.continueAs': 'Continue as',
    'voucher.loginDiffernt': 'Login with a different account',
    'voucher.login': 'Login',
    'voucher.signup': 'Signup',
    'voucher.invalidCode': 'This voucher code is unfortunately not valid, please enter valid voucher code',
    'voucher.codeReedemed': 'This voucher code is already reedemed. Please contact Quip support',
    'voucher.voucherManagement': 'Voucher Management',
    'voucher.voucherEnrollManagement': 'Voucher Enrollment Management',
    'voucher.upload': 'Upload Vouchers',
    'voucher.invalidCodeLength': 'Every code must be ten characters long',
    'voucher.invalidFormatting': 'wrong code format. Please make sure of the proper formatting: xxxx-xxxxxx',
    'voucher.claimedOn': 'Claimed on',
    'voucher.finalizeMessage': 'To finalize enrollment, please click "ENROLL TO TRIAL"',
    'voucher.incompatible': 'This trial is not marked as voucher compatible',
    'voucher.acceptEverything': 'I accept',
    'voucher.acceptTerm1': 'Please accept our',
    'voucher.acceptTerm2': 'Terms and Conditions',
    'voucher.acceptModality1': 'and the special',
    'voucher.acceptModality2': 'modalities',
    'voucher.acceptModality3': 'that are applicable to this QuIP product',
    'voucher.alreadyEnrolled': 'You are already enrolled in this trial',
    'vouhcer.enrollmentStatus': 'Enrollment Status',
    'voucher.trialFull': 'This trial is now full. Please contact QuIP support',
    'feedback.feedbackView': 'Feedback',
    'feedback.export': 'Export Feedback',
    'internalTrial.enroll': 'Enroll internal user',
    'internalTrial.enrollUser': 'Enroll User',
    'internalTrial.bulkRegister': 'Bulk register',
    'internalTrial.bulkStep1': 'Upload CSV',
    'internalTrial.bulkStep2': 'Download results',
    'internalTrial.bulkStep3': 'Register participants',
    'internalTrial.bulkStep1Description': 'Upload a CSV or Excel file that contains an "email" column. Only that column will be used; duplicate emails are processed once.',
    'internalTrial.bulkStep1SkipHint': 'Already have a Phase 2 file? Skip to register participants.',
    'internalTrial.bulkSkipToRegister': 'Skip to register participants',
    'internalTrial.bulkStep2Description': 'Download the results (Matched and Unmatched sheets), then proceed to register.',
    'internalTrial.bulkStep3Description': 'Re-upload the downloaded file (Phase 2 format with Matched sheet). Enter the exact trial name below to confirm, then register.',
    'internalTrial.bulkSummary': '{matched} matched, {unmatched} unmatched',
    'internalTrial.bulkDownload': 'Download results',
    'internalTrial.bulkNext': 'Next',
    'internalTrial.bulkTrialNameLabel': 'Trial name (exact, case-sensitive)',
    'internalTrial.bulkRegisterConfirm': 'Register participants',
    'internalTrial.bulkImportMissingEmailColumn': 'The file must contain an "email" column.',
    'internalTrial.bulkImportNoEmails': 'No valid emails found in the file.',
    'internalTrial.bulkImportError': 'Failed to parse or process the file.',
    'internalTrial.bulkEnrollMissingQidColumn': 'The file must contain a "Quip Id" or "QID" column (from the Phase 2 download).',
    'internalTrial.bulkEnrollNoValidQids': 'No valid Quip Ids found in the file.',
    'internalTrial.bulkTrialNameMismatch': 'Trial name does not match. Enter the exact name to prevent mistakes.',
    'internalTrial.bulkReuploadRequired': 'Please upload the file (Phase 2 format) to register.',
    'internalTrial.bulkEnrollError': 'Bulk enrollment failed.',
    'internalTrial.bulkEnrollPartial': 'Some enrollments failed.',
    'internalTrial.bulkEnrollResult': 'Enrolled: {enrolled}, Failed: {failed}',
    'internalTrial.bulkEnrollResultWithSkipped': 'Enrolled: {enrolled}, Skipped (already registered): {skipped}, Failed: {failed}',
    'internalTrial.bulkBackToDownload': 'Back to download results',
    'internalTrial.notifyRegisteredUsers': 'Notify registered users',
    'internalTrial.notifyRegisteredUsersLoading': 'Loading participants…',
    'internalTrial.notifyNoRegisteredUsers': 'There are no approved registrations yet.',
    'internalTrial.notifyColQid': 'Quip Id',
    'internalTrial.notifyColName': 'Name',
    'internalTrial.notifyColInstitute': 'Institute',
    'internalTrial.notifyColForwardAddresses': 'Notification forwards',
    'internalTrial.notifyColEmail': 'Email',
    'internalTrial.notifySendEmail': 'Send email',
    'internalTrial.notifySelectAll': 'Select all users',
    'internalTrial.notifySendPrepared': 'Notifications prepared successfully.',
    'internalTrial.notifySendError': 'Could not prepare notifications.',
    'usermanagement.nothingToDo': 'Nothing to do here',
    'usermanagement.resendActivation': 'Resend activation',
    'usermanagement.deleteUser': 'Delete User',
    'usermanagement.deleteUserConfirmationTitle': 'Confirm User Deletion',
    'usermanagement.deleteUserConfirmationText': 'Are you sure to delete the following user: ',
    'userManagement.updateInstitute': 'Update Institute',
    'userManagement.updateInstituteForUser': 'Update Institute for User',
    'userManagement.assignInstitute': 'Assign Institute',
    'instituteManagement.instituteManagement': 'Institute Management',
    'instituteManagement.registeredUsers': 'Registered Users',
    'instituteManagement.registerdInstitutes': 'Registered Institutes',
    'instituteManagement.confirmDelete': 'Are you sure you want to delete this Institute',
    'instituteManagement.showUsers': 'Show Users',
    'instituteUser.addUsers': 'Add Users',
    'enrollment.recordNotFound': 'No record found',
    'enrollment.userNotVerfied': 'User not verified',
    'enrollment.userDeactivated': 'User deactivated',
    'enrollment.noUserFromQuip': 'No registration for QuIP members. Most QuIP members are administrators and trials submission are not supported for these roles',
    'DRT.confirmDeleteSection': 'Deleting the section will also delete its cases',
    'DRT.gtRangeError': 'Please make sure the minimum range value is not greater than maximum range value',
    'DRT.gtNumberError': 'Please make sure, all values are numbers up to two decimal places',
    'DRT.noRegularEnroll': 'Please enter the missing institute data for this under "Account". You will need to wait for verification by QuIP.',
    'DRT.startExam': 'Please select an antibody to perform the test. You can no longer change the antibody. If you continue, start the Digital Readout Test. You have a total of {x} minutes to complete the digital readout, but you can pause at any time.',
    'DRT.continueExam': 'Would you like to continue with the Digital Readout Test now? There are still {x} minutes left in your time allotment for implementation.',
    'DRT.finalizeSubmission': 'Are you sure you want to submit the results and complete the Digital Readout Test? Subsequent changes and a review of your results are then no longer possible.',
    'DRT.resultNotification': 'This is an overview of the maximum possible number of points and the number of points actually achieved. You will only receive more detailed information on your performance in comparison to the other participants and the correct answers after the implementation period has expired under Evaluation.',
    'billingAddress.add': 'Add Billing Address',
    'billingAddress.heading': 'Add/Select your billing addres',
    'billingAddress.title': 'Billing address(es) for personal digital readout tests',
    'billingAddress.deletePrompt': 'Are you sure you want to delete this billing address',
    'billingAddress.addInstitute': 'Setup Institute Address as Billing Address',
    'billingAddress.noInstitute': 'Unfortunately, you don\'t have an Institute Address',
    'numberRangeQuestionInput.invalidNumber': 'Please enter a valid number (e.g 1, 1.3, 1.01, allowed up to two decimal places) or RTU or -',
    'ratioQuestionInput.invalidNumber': 'Please enter valid ratio (e.g 1:40) or RTU or -',
    'answerSummary.title': 'Answer Summary',
    'answerSummary.questionTitle': 'Questions',
    'referencelink.title': 'Reference Links',
    'referenceLink.addText': 'Add reference links to the section:',
    'referenceLink.urlError': 'One or more reference links are invalid',
  },
  de: {
    newQuipReleaseNotificationTitle: 'Login (altes QuIP Softwaresystem)',
    newQuipReleaseNotification: 'Bitte beachten Sie: Die Anmeldung für Ringversuche findet ab 2026 in unserem neuen {webshop} statt. Wenn Sie Neukunde sind, benötigen Sie zwei separate Benutzerkonten: QuIP Customer Center (QCC): erforderlich, um unsere Ringversuche zu bestellen. Altes QuIP-Softwaresystem: erforderlich, um Ergebnisse einzugeben, Ihre Auswertungen einzusehen und Zertifikate herunterzuladen.',
    genericSaveMessage: 'Ihre Änderungen wurden gespeichert',
    genericErrorMessage: 'Leider gab es ein Problem bitte probieren Sie es noch einmal',
    genericCancel: 'Abbrechen',
    confirm: 'Bestätigen',
    genericClose: 'Schliessen',
    genericDelete: 'Löschen',
    genericUploadFile: 'Datei hochladen',
    save: 'Speichern',
    back: 'Zurück',
    next: 'Weiter',
    yes: 'ja',
    no: 'nein',
    warning: 'Warnung',
    duplicate: 'duplizieren',
    none: 'Keiner',
    done: 'Erledigt',
    edit: 'Bearbeiten',
    approve: 'genehmigen',
    add: 'Hinzufügen',
    note: 'Hinweis',
    groundtruthNo: 'groundTruth No.',
    section: 'Sektion: ',
    overall: 'Gesamt: ',
    pass: 'Bestanden',
    fail: 'Nicht Bestanden',
    notFinalized: 'Nicht abgeschlossen',
    'trialsTablabel.individual': 'Individuell',
    'trialsTablabel.institute': 'Institut',
    'print.choosePrintMode': 'Druckmodus wählen',
    'print.printSummary': 'Meine Einreichung drucken',
    'print.printWhole': 'Kompletter Fragebogen drucken',
    'print.pageLayout': 'Seitenlayout',
    'print.portrait': 'Hochformat',
    'print.landscape': 'Querformat',
    'print.pagebreak': 'Seitenumbruch',
    'salutation.mr': 'Herr',
    'salutation.ms': 'Frau',
    'position.employee': 'Angestellter',
    'position.headOfInstitute': 'Institutsleiter',
    'changePassword.oldPasswordLabel': 'Altes Passwort',
    'changePassword.newPasswordLabel': 'Neues Passwort',
    'changePassword.success': 'Ihr Passwort wurde geändert',
    'changePassword.oldPasswordIncorrect': 'Ihr altes Passwort ist inkorrekt',
    'menu.home': 'Nutzerdaten',
    'menu.admin': 'Admin',
    'menu.trialRegister': 'Anmeldung',
    'menu.reviews': 'Reviews',
    'menu.trials': 'Ringversuche / Digital Readout Tests',
    'menu.users': 'Benutzer',
    'menu.institute': 'Institut',
    'menu.logout': 'Logout',
    'menu.login': 'Login',
    'menu.surveys': 'Fragebögen',
    'menu.mySurveys': 'Meine Fragebögen',
    'mysurvey.emptySectionWarning': 'Leere Sektionen gefunden',
    'menu.submissions': 'Übermittelungen',
    'menu.enrollments': 'Teilnahmen & Rechnungen',
    'menu.certificates': 'Zertifikate',
    'menu.quipBioMarker': 'QuIP Biomarker Portale',
    'menu.pdl1Portal': 'PD-L1 Portal',
    'menu.lungenkarzinomPortal': 'Lungenkarzinom Portal',
    'menu.mammakarzinomPortal': 'Mammakarzinom Portal',
    'menu.msiDmmrPortal': 'MSI/dMMR Portal',
    'menu.fgfrPortal': 'FGFR Portal',
    'menu.hrdPortal': 'HRD Portal',
    'passwordRequest.heading': 'Neues Passwort beantragen',
    'passwordRequest.buttonLabel': 'Passwort beantragen',
    'passwordRequest.goToLogin': 'Zum Login',
    'legend.title': 'Legende',
    'legend.correct': 'Richtige Antwort',
    'legend.acceptable': 'Akzeptierte Antwort',
    'legend.false': 'Falsche Antwort',
    'legend.review': 'Review Antwort',
    'legend.dismissed': 'Nicht abgefragt für den Fall',
    'legendAggergation.reviewCount': 'Teilnehmer mit Review-Punkten',
    'legendAggergation.nonReviewCount': 'Teilnehmer ohne Review-Punkte',
    'legendAggergation.rightAnswers': 'Fett gedruckte Antworten: Richtige Antworten',
    'login.expired': 'Ihr Zugang ist abgelaufen, bitte loggen Sie sich erneut ein',
    'login.signupLabel': 'Noch kein Account?',
    'login.signupLink': 'Jetzt registrieren',
    'login.forgotPasswordLabel': 'Passwort vergessen?',
    'login.requestPasswordLink': 'Password zurücksetzen',
    'login.tryAgain': 'Erneut eingeben',
    'login.valueMissing': 'Eingabe fehlt',
    'login.emailNotActivated': 'Die Email ({email}) wurde noch nicht verifiziert. Bitte schauen Sie in Ihr EMail Postfach.',
    'login.userdoesnotexist': 'Der eingegebene Benutzer ({email}) existiert nicht.',
    'login.usernotactivate': 'Der Benutzer {email} ist nicht aktiviert worden. Bitte kontaktieren Sie den Administrator',
    'login.invalidCredentials': 'Die für {email} eingegebenen Anmeldedaten sind falsch.',
    'login.generalloginerror': 'Die Angaben sind ungültig',
    'login.internetExplorerWarning': 'Internet Explorer wird nicht unterstützt. Bitte verwenden Sie Google Chrome für die beste Erfahrung.',
    'login.switchToGermany': 'Bitte wechseln Sie von der oberen rechten Ecke in die deutsche Region QuIP.',
    'login.switchToInternational': 'Bitte wechseln Sie von der oberen rechten Ecke in die internationale Region von QuIP.',
    'login.qccTitle': 'QuIP Customer Center',
    'login.qccDescription': 'Melden Sie sich im neuen QuIP Customer Center (QCC) an, um Ihr Benutzerkonto, Ihre Organisation und Ihre Abteilungen zu verwalten sowie auf den QuIP Shop zuzugreifen um sich bei Ringversuch zu registrieren.',
    'login.qccButton': 'QuIP Customer Center öffnen',
    'login.or': 'ODER',
    'resetPassword.passwordsDoNotMatch': 'Passwörter stimmen nicht überein',
    'resetPassword.heading': 'Neues Passwort eingeben',
    'resetPassword.passwordLabel': 'Passwort',
    'resetPassword.passwordConfirmLabel': 'Passwort bestätigen',
    'resetPassword.buttonLabel': 'Zurücksetzen',
    'resetPassword.success': 'Ihr Passwort wurde geändert',
    'resetPassword.emailError': 'Wir können keinen Benutzer mit dieser E-Mail Adresse finden',
    'resetPassword.resetEmailSend': 'Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts geschickt',
    'registration.noValidVat': 'Bitte geben Sie eine gültige Umsatzsteuernummer ein (z.B: {example} für {country})',
    'registration.headline': 'Registrierung',
    'registration.required': 'Erforderlich',
    'registration.instituteInformationHeading': 'Institutsanschrift und Versandadresse der Testsets',
    'registration.instituteInfoLabel': 'Angaben zum Institut',
    'registration.instituteName': 'Name des Instituts',
    'registration.instituteNameWithLeadName': 'Name des Instituts',
    'registration.hospitalName': 'Name des Krankenhauses',
    'registration.instituteCity': 'Stadt',
    'registration.instituteStreet': 'Strasse',
    'registration.instituteHousenumber': 'Hausnummer',
    'registration.instituteAdditionalAddress': 'Adresszusatz (Gebäude, Haus, Raum, Stockwerk, Eingang)',
    'registration.instituteZip': 'PLZ',
    'registration.instituteCountry': 'Land',
    'registration.userCountry': 'Land',
    'registration.institutePhone': 'Telefonnummer des Instituts',
    'registration.instituteEmail': 'E-Mail des Instituts',
    'registration.instituteFax': 'Faxnummer des Instituts',
    'registration.instituteID': 'Institutskennzeichen',
    'registration.instituteTaxID': 'USt-IdNr.',
    'registration.instituteComments': 'zusätzliche Kommentare',
    'registration.invoiceName': 'Rechnungsanschrift des Instituts',
    'registration.invoiceCity': 'Stadt',
    'registration.invoiceStreet': 'Strasse',
    'registration.invoiceHousenumber': 'Hausnummer',
    'registration.invoiceZip': 'PLZ',
    'registration.invoiceCountry': 'Land',
    'registration.aboutInvoiceAddress': 'Diese Adresse ist optional. Sollten Sie keine Rechnungsadresse angeben, wird die Adresse aus Schritt 1 als Rechnungsadresse übernommen.',
    'registration.invoiceNote': '* Ihre institutsinterne Auftragsnummer/Kostenstelle (falls notwendig) können Sie bei der Rechnungserstellung am Ende des Bestellvorgangs für jeden Ringversuch separat angeben.',
    'registration.certificationName': 'Zertifizierungsanschrift des Instituts',
    'registration.certificationCity': 'Stadt',
    'registration.certificationStreet': 'Strasse',
    'registration.certificationHousenumber': 'Hausnummer',
    'registration.certificationZip': 'PLZ',
    'registration.certificationCountry': 'Land',
    'registration.requiredMessage': 'Bitte füllen Sie alle Felder aus',
    'registration.invoiceInformationHeading': 'Rechnungsadresse des Instituts (optional)',
    'registration.userGender': 'Anrede',
    'registration.userTitle': 'Titel',
    'registration.personalInformationHeading': 'Angaben zur Ihrer Person',
    'registration.userFirstName': 'Vorname',
    'registration.userLastName': 'Nachname',
    'registration.email': 'Email',
    'registration.userTitle.phd': 'Dr.',
    'registration.userTitle.prof': 'Prof.',
    'registration.userPosition': 'Ihre Rolle im Institut',
    'registration.userPositionEmployee': 'Mitarbeiter',
    'registration.userPositionDirector': 'Institutsleiter',
    'registration.userCommLanguage': 'Sprache für Emails',
    'registration.userCommLanguageGerman': 'Deutsch',
    'registration.userCommLanguageEnglish': 'Englisch',
    'registration.userEmail': 'E-Mail',
    'registration.userPassword': 'Passwort',
    'registration.userPasswordConfirm': 'Passwort bestätigen',
    'registration.emailAlreadyExists': 'Eine Anmeldung mit dieser Emailadresse liegt uns bereits vor',
    'registration.agbAccept': 'Bitte akzeptieren Sie die AGB',
    'registration.userAGBAcceptLabel': 'Ich akzeptiere die AGB',
    'registration.noEmptyField': 'Bitte befüllen Sie das Feld',
    'registration.noValidMail': 'Ihre Eingabe ist keine gültige E-Mail Adresse',
    'registration.noValidZip': 'Bitte geben Sie nur Zeichen von [0-9][A-Z][a-z][_.-/ ] mit einer Länge von 2 bis 10 Zeichen ein.',
    'registration.noSpaceCharacter': 'Leerzeichen sind nicht erlaubt',
    'registration.overview': 'Überblick',
    'registration.submit': 'Abschicken',
    'registration.patientCare': 'In der Patientenversorgung tätig',
    'registration.isCompany': 'Unternehmen',
    'registration.passwordsNotMatch': 'Passwörter stimmen nicht überein',
    'registration.activationSuccessful': 'Ihre Registrieung ist nun abgeschlossen',
    'registration.activationFailure': 'Problem während der Aktivierung',
    'registration.genericActivationFailure': 'Ein unbekannter Fehler trat während der Aktivierung auf. Bitte kontaktieren Sie uns unter: ringversuche@quip.eu',
    'registration.newsletterOptIn': 'Ich erkläre mich damit einverstanden, dass die QuIP GmbH mir regelmäßig Informationen über Updates zum Programm und Informationen zu Ringversuchen zusendet',
    'registration.requiredFieldsText': 'Mit einem * gekennzeichnete Eingabefelder sind Pflichtfelder.',
    'registration.afterSubmitText': 'Nachdem Sie die Anmeldung durchgeführt haben, erhalten Sie eine E-Mail mit einem Aktivierungslink. Bitte folgen Sie den Anweisungen der E-Mail um Ihre Registrierung abzuschließen.',
    'registration.patientCareDescription': 'Patientenversorger sind Institute/Einrichtungen für Pathologie welche direkt in die Krankenversorgung/Diagnostik involviert sind. Diese werden bei der Zuteilung der Ringversuchsproben bevorzugt behandelt.',
    'registration.aboutDeliveryAddress': 'Diese Adresse gilt als Versandadresse (Lieferungen an Postfächer sind nicht möglich)',
    'registration.outdatedToken': 'Der Aktivierungslink ist veraltet. Wir schicken Ihnen umgehend einen neuen Link. Bitte überprüfen Sie Ihren Posteingang',
    'registration.doubleConfirmation': 'Die Anmeldung wurde bereits bestätigt. Bitte loggen Sie sich ein',
    'registration.clearanceHandlerHeading': 'Bitte geben Sie den Namen und die Kontaktinformationen der Person an, die für Zoll- und Logistikangelegenheiten zuständig ist:',
    'reigstration.info.custom': 'Zollabfertigungsinformationen',
    'registration.info.certificate': 'Zollabfertigungsinformationen',
    'registration.info.invoice': 'Zertifikat Adressinformationen',
    'registration.customClearanceUser': 'Name',
    'registration.customClearanceContact': 'Telefon',
    'registration.customClearanceEmail': 'E-Mail',
    'registration.eoriNumber': 'EORI Nummer',
    'registration.invoicedifferent': 'Rechnungsadresse anders',
    'registration.certificatedifferent': 'Zertifikatsadresse anders',
    'registration.selectInstitute': 'Bitte wählen Sie Ihr Institut aus',
    'registration.mustMatch': 'Das Passwort muss übereinstimmen',
    'registration.skipandsubmit': 'Überspringen und fortfahren',
    'registration.skipWarning': 'Bitte beachten Sie, dass Sie bei einer Anmeldung ohne Institut persönliche Produkte wie digitale Auslesetests von QuIP nutzen können, aber um am regulären Ringversuch teilnehmen zu können, müssen Sie einem Institut angehören.',
    'adminview.headline': 'Administration',
    'adminview.userManagementTab': 'Benutzer',
    'adminview.enrollmentsManagementTab': 'Teilnahmen',
    'adminview.customFieldsManagementTab': 'Benutzerdefinierte Felder',
    'adminview.trialManagementTab': 'Ringversuche',
    'account.welcome': 'QuIP Kundenbereich',
    'account.loginMessage': 'Sie sind aktuell eingeloggt als',
    'account.enrolledTrials': 'Sie sind zu den folgenden Ringversuchen angemeldet',
    'account.customerInformation': 'Ihre persönlichen Daten',
    'account.logout': 'abmelden',
    'account.forwardAddressesHeading': 'E-Mail Benachrichtigungs Adressen',
    'account.forwardAddressesHeading.helpTitle': 'E-Mail Benachrichtigungs Hilfe',
    'account.forwardAddressesHeading.helpText': 'In dieser Sektion können Sie bis zu 3 Empfänger für Benachrichtigungen eintragen',
    'account.forwardMailDescription': 'Sie können bis zu 3 E-Mail Adressen eintragen welche alle Benachrichtigungen erhalten',
    'account.changeForwardAddress': 'E-Mail Addresse eintragen',
    'account.changePasswordLabel': 'Password ändern',
    'account.passwordsDoNotMatch': 'Die Passwörter müssen übereinstimmen',
    'account.instituteAddress': 'Adresse des Instituts',
    'account.certificateAddress': 'Adresse des Zertifikats',
    'account.invoiceAddress': 'Rechnungsanschrift',
    'admindetails.unverifiedUsers': 'Folgende User erfordern eine Verifizierung',
    'admindetails.declareReviewers': 'Reviewer verwalten',
    'admindetails.resetEmailAdress': 'Reset Email',
    'admindetails.resetEmailNewEmailHint': 'Enter new email address',
    'admindetails.resetEmailButton': 'Reset Email',
    'admindetails.selectRegistrationData': 'Institutsdaten aus Registrierung verwenden',
    'admindetails.existingInstituteData': 'Existierende Institutsdaten verwenden',
    'admindetails.generalActions': 'Allgemein',
    'admindetails.exportAllUsers': 'User Export',
    'admindetails.exportAllInstitutes': 'Institut Export',
    'admindetails.masterBookingListHeadline': 'Master-Buchungsliste',
    'admindetails.masterBookingListButton': 'Buchungsliste erstellen',
    'admindetails.masterBookingStartDate': 'Start Datum',
    'admindetails.masterBookingEndDate': 'End Datum',
    'admindetails.usersManagement': 'Benutzerverwaltung',
    'trials.trialCode': 'Code',
    'trials.trialYear': 'Jahr',
    'trials.trialName': 'Testbezeichnung',
    'trials.status': 'Status',
    'trials.enrollmentstatus': 'Teilnahme',
    'trials.startDate': 'Start Zeitraum',
    'trials.endDate': 'Abgabe',
    'trials.endDateUntil': 'Abgabe bis',
    'trials.registrationStartDate': 'Registrierung beginnt am',
    'trials.registrationEndDate': 'Registrierung endet am',
    'trials.newPostSubmissionDate': 'Nachreichefrist bis',
    'trials.numParticipants': 'Anzahl der Teilnehmer',
    'trials.numSamples': 'Anzahl Fälle',
    'trials.price': 'Preis',
    'trials.enroll': 'Zur Anmeldung',
    'trials.enroller': 'Anmelder',
    'trials.tag': 'Methode/Typ',
    'trials.samplesDelivered': 'Auslieferungen',
    'trials.enrollmentRole': 'Anmelder Rolle',
    'trials.changeEnrollmentRole': 'Anmeldung Rolle ändern',
    'trials.rowsPerPageLabel': 'Anzahl der Ringversuche',
    'trialConfirmation.headline': 'Weiter zur Rechnungsstellung',
    'trialConfirmation.confirm': 'Verbindlich Anmelden',
    'trialConfirmation.cancel': 'Abbrechen',
    'trials.searchHeading': 'Suche',
    'trials.searchHeading.helpTitle': 'Suche Ringversuche Hilfe',
    'trials.searchHeading.helpText': 'Suchen Sie nach Ringversuchen, die derzeit für die Registrierung geöffnet sind.',
    'trials.searchButtonLabel': 'Suchen',
    'trials.searchHint': 'Suchbegriff',
    'trials.resetButtonLabel': 'Zurücksetzen',
    'trials.manual': 'Anleitung',
    'trials.noTrialsFound': 'Es wurde kein Ringversuch mit diesen Suchkriterien gefunden',
    'trials.showDeactivateTrials': 'archivierte Ringversuche anzeigen',
    'trials.showCompletedTrials': 'abgeschlossene Ringversuche anzeigen',
    'trials.trialIsFull': 'Restplätze nur über Warteliste',
    'trials.registraionClosed': 'Die Registrierung für diesen Ringversuch ist noch nicht offen.',
    'trials.registrationEnd': 'Die Registrierung für diesen Ringversuch wurde beendet',
    'trials.alreadyEnrolled': 'Benutzer bereits angemeldet',
    'trials.noGermanInstitute': 'Institute aus Deutschland dürfen sich leider nicht in diese Ringversuch anmelden',
    'trials.instituteUnapproved': 'Ihr Institut steht noch zur Genehmigung an. Bitte versuchen Sie es später noch einmal.',
    'trialdetails.header': 'Ringversuch Details',
    'trialdetails.surname': 'Nachname',
    'trialdetails.firstname': 'Vorname',
    'trialdetails.title': 'Titel',
    'trialdetails.city': 'Stadt',
    'trialdetails.attendeeName': 'Teilnehmer Name',
    'trialdetails.attendeeInstitute': 'Institut',
    'trialdetails.patientCare': 'Patientenversorgung',
    'trialdetails.status': 'Status',
    'trialdetails.invoiced': 'Rechnung erstellt',
    'trialdetails.statusApproved': 'zugelassen',
    'trialdetails.statusApplied': 'offen',
    'trialdetails.statusRejected': 'abgelehnt',
    'trialdetails.statusCancelled': 'storniert',
    'trialdetails.actionApprove': 'Teilnahme Bestätigen',
    'trialdetails.actionReject': 'Teilnahme Ablehnen',
    'trialdetails.cancelInvoice': 'Rechnung Stornieren',
    'trialdetails.downloadInvoice': 'Rechnung herunterladen',
    'trialdetails.downloadCancelledInvoice': 'Storno Rechnung herunterladen',
    'trialdetails.actionCancel': 'Teilnahme Stornieren',
    'trialdetails.showCertificate': 'Zertifikat anzeigen',
    'trialdetails.approveCertificate': 'Zertifikat bestätigen',
    'trialdetails.uploadCertificate': 'Zertifikat hochladen',
    'trialdetails.actionShowSubmission': 'Einreichung anzeigen',
    'trialdetails.unfinalizedButtonDisableTooltip': 'Entweder hat der Nutzer seine Einreichung nicht abgeschlossen oder der Versuch ist beendet',
    'trialdetails.postResubmitButtonDisabled': 'Die Ringversuch ist noch nicht beendet',
    'trialdetails.trialIsDeactivated': 'Die Ringversuch ist deaktiviert. Es sind keine Änderungen möglich.',
    'trialdetails.certificatedIsApproved': 'Das Zertifikat ist bestätigt. Es sind keine Änderungen möglich.',
    'trialdetails.enrollmentCancelled': 'Eine Anmeldung wird nicht genehmigt, Änderungen sind nicht möglich',
    'trialdetails.allowPostResubmit': 'Nachträgliche Änderung erlauben',
    'trialdetails.postResubmitWarning': 'Die Einreichung wurde abgeschlossen. Wenn Sie mit der Option "Nachträgliche Änderung erlauben" fortfahren, wird der Abschluss der Einreichung dieses Teilnehmers zurückgesetzt.',
    'trialdetails.postResubmitTrialNotEnd': 'Der Ringversuch ist noch nicht beendet. Bitte wählen Sie ein Datum nach dem Enddatum des Ringversuchs.',
    'trialdetails.pricedescription': 'ggf. zzgl. MwSt und Versandkosten',
    'trialdetails.trialStatus': 'Status des Ringversuchs',
    'trialdetails.recreateCertificate': 'Zertifikat re-generieren',
    'trialdetails.recreateCertificateSuccess': 'Zertifikat erfolgreich neu erstellt',
    'trialdetails.showReview': 'Review anzeigen',
    'trialdetails.evaluate': 'Groundtruth Anwenden',
    'trialdetails.releaseEvaluation': 'Auswertung freigeben',
    'trialdetails.unapproveCertificate': 'Zertifikat unapproven',
    'trialdetails.unapproveButton': 'Unapproven',
    'trialdetails.unapproveCertificateWarning': 'Sind Sie sicher, dass Sie das Zertifikat unapproven möchten. Dieser Vorgang wird protokolliert und kann nicht rückgägig gemacht werden!!',
    'trialdetails.unapproveReasonTextfield': 'Bitte geben Sie einen Grund bzw. eine Referenznotiz für diesen Vorgang an.',
    'trialdetails.sectionReview': 'Kommentare der Sektion',
    'trialdetails.sectionOverview': 'Allgemeine Kommentare',
    'trialdetails.reviewTitle': 'Review Ergebnisse',
    'trialdetails.textBlockReviewTitle': 'Reviewkommentare aus der Sektion',
    'trialdetails.surveyTitle': 'Fragebogen Ergebnisse',
    'trialdetails.enrollDate': 'Anmeldedatum',
    'trialdetails.sampleset': 'Setnummer',
    'trialdetails.gtgroup': 'GroundTruth-Gruppe',
    'trialdetails.downloadCertBundle': 'Zertifikat-Bundle herunterladen',
    'trialdetails.unknownEnrollmentStatus': 'unbekannt',
    'trialdetails.submissionStatus': 'Status des Abschlusses',
    'trialdetails.notstarted': 'Nicht gestartet',
    'trialdetails.submissionfinalizedTrue': 'Abgeschlossen',
    'trialdetails.submissionfinalizedFalse': 'In Bearbeitung',
    'trialdetails.failRate': 'Fehlerrate',
    'trialdetails.postResubmitMessage': 'Wählen Sie eine neue Frist für die Einreichung von {trialCode} durch {title} {lastName}',
    'trialdetails.confirmCancelInvoice': 'Sind Sie sicher, dass Sie die Rechnung stornieren möchten?',
    'trialdetails.confirmCancelEnrollment': 'Sind Sie sicher, dass Sie die Teilnahme stornieren möchten?',
    'trialSearch.typeSelectHeading': 'Typ',
    'trialSearch.yearSelectHeading': 'Jahr',
    'trialSetup.trialsettingHeadline': 'Ringversuchseinstellungen',
    'trialSetup.registrationHeadline': 'Registrierungseinstellungen',
    'trialSetup.certificateHeadline': 'Zertifikateinstellungen',
    'trialSetup.reviewHeadline': 'Revieweinstellungen (Experimental)',
    'trialSetup.archiveHeadline': 'Archivierung',
    'trialSetup.successTemplate': 'Template für Zertifikat',
    'trialSetup.failTemplate': 'Template für Teilnahmebescheinigung',
    'trialSetup.trialAvailability': 'Ringversuchsreichweite',
    'trialSetup.trialIsInternationl': 'International',
    'trialSetup.availableForBoth': 'Auf qualityinpathology.com und quip.eu einstellen (Rechnung und Zertifikat werden auf Englisch ausgestellt)',
    'trialSetup.isDRT': 'Digital Readout Test',
    'trialSetup.makeAsDRT': 'Als DRT anlegen',
    'trialSetup.survey': 'Fragebogen: {trialName}',
    'trialSetup.publish': 'Überprüfen und Veröffentlichen',
    'trialSetup.setInstitute': 'Setzen',
    'trialSetup.changeInstitute': 'Ändern',
    'trialSetup.removeInstitute': 'Entfernen',
    'trialSetup.instituteNameColumn': 'Name',
    'trialSetup.instituteCityColumn': 'Stadt',
    'trialSetup.chooseInstitute': 'Auswählen',
    'trialSetup.customFields': 'Benutzerdefinierte Felder',
    'trialSetup.dateMustBeBeforeStartDate': 'Datum muss vor dem Untersuchungszeitraum liegen',
    'trialSetup.dateMustBeBeforeRegistrationStartDate':
      'Datum muss vor dem Registrierungsstartdatum liegen',
    'trialSetup.deactivateTrial': 'Ringversuch archivieren',
    'trialSetup.dateMustBeAfterStartDate':
      'Datum muss nach dem Startdatum des Untersuchungszeitraums liegen',
    'trialSetup.fieldEmpty': 'Feld kann nicht leer sein',
    'trialSelector.createSurveyButton': 'Fragebogen erstellen',
    'trialSetup.hintFreeText1': 'Antikoerper',
    'trialSetup.hintFreeText2': 'Automat',
    'trialSetup.trialName': 'Testbezeichnung',
    'trialSetup.trialCode': 'Code des Ringversuchs',
    'trialSetup.startDate': 'Ringversuchsbeginn',
    'trialSetup.endDate': 'Ringversuchsende',
    'trialSetup.registrationStartDate': 'Registrierungsbeginn',
    'trialSetup.registrationEndDate': 'Registrierungsende',
    'trialSetup.amountParticipants': 'Anzahl der Teilnehmer',
    'trialSetup.price': 'Preis in Euro',
    'trialSetup.numberOfSamples': 'Anzahl der Fälle',
    'trialSetup.leadOnCertificate': 'Lead des Ringversuchs auf Zertifikat',
    'trialSetup.nameOnCertificate': 'Name des Ringversuchs auf Zertifikat',
    'trialSetup.label': 'Geben Sie das Etikett für die Ringversuch ein',
    'trialSetup.parentTrialId': 'Name des Elternversuchs',
    'trialSetup.costCenter': 'Kostenstelle',
    'trialSetup.trialType': 'Typ des Ringversuchs',
    'trialSetup.trialCategory': ' Methode der Registrierung',
    'trialSetup.textblockComments': 'Textblockkommentare (Datei bitte über Review verwalten hochladen)',
    'trialSetup.textblockCommentTitle': 'Textblockkommentare',
    'trialSetup.educativeComments': 'Edukative Review (Färbung Review)',
    'trialSetup.reviewCategory': 'Review kategorie',
    'trialSetup.trialTypePathology': 'Pathologie',
    'trialSetup.trialTypeNeuropathology': 'Neuropathologie',
    'trialSetup.datesCanNotBeTheSame': 'Start- und Enddatum können nicht gleich sein',
    'trialSetup.surveyHeadline': 'Einstellungen zum Fragebogen',
    'trialSetup.surveySelectionLabel': 'Fragebogen Version',
    'trialSetup.reviewSelectionLabel': 'Reviewkategorie',
    'trialSetup.excludeShippingFee': 'Ohne Versandkosten',
    'trialSetup.excludeShippingFeeText': 'Alle Versandkosten werden mit 0,00 € berechnet.',
    'trialSetup.excludeAdminFee': 'Ohne Verwaltungskosten',
    'trialSetup.excludeAdminFeeText': 'Alle Verwaltungskosten werden mit 0,00 € berechnet.',
    'trialSetup.accredited': 'akkreditiert',
    'trialSetup.notAccredited': 'nicht akkreditiert',
    'trialSetup.accreditedMessage': 'Ist Ringversuche akkreditiert?',
    'trialSetup.accreditedMessage2': 'Ist akkreditiert',
    'trials.accreditedStatus': 'Akkreditierungsstatus DIN EN ISO/IEC 17043:2023',
    'payment.heading': 'Zahlung der Teilnahme am Ringversuch',
    'payment.payoneUrlGenerationError': 'Fehler während des Bezahlvorgangs. Bitte kontaktieren Sie uns unter: ringversuche@quip.eu',
    'payment.creditCard': 'Kreditkarte',
    'payment.pending': 'Wir haben noch keine Zahlungsbestätigung erhalten, bitte versuchen Sie es später noch einmal.',
    'payment.bankTransfer': 'Überweisung',
    'payment.elvMandateText': 'Das Mandat für die Lastschriftzahlung ist einmalig für diese Zahlung gültig.',
    'payment.invoice': 'Rechnung',
    'payment.debitPayment': 'Sepa Lastschrift',
    'payment.method': 'Zahlungsart',
    'payment.redirectMessage': 'Sie werden zu unserem Zahlungspartner weitergeleitet. Sollte keine Weiterleitung stattfinden klicken Sie ',
    'payment.redirectMessageInvoice': 'Zahlung per Rechnung erfolgreich erstellt. Sie werden zum Rechnungsgenerator weitergeleitet. Klicken Sie auf den Link, wenn Sie für einige Zeit nicht weitergeleitet werden. ',
    'payment.redirectLink': 'hier',
    'payment.proceedToPayment': 'Weiter zur Zahlung',
    'payment.invoiceConfirmationTextRec': 'Bitte generieren Sie nun hier die Rechnung und überweisen Sie anschließend den Betrag auf das angegebene Konto.',
    'payment.invoiceConfirmationText': 'Die Eingabe der Zahlungsdaten war erfolgreich.',
    'payment.success': 'Ihre Zahlung war erfolgreich, nach dem Eingang Ihrer Zahlung auf unserem Konto (max. 2 Werktage) können Sie sich hier für Ihre Buchhaltung die Rechnung generieren.',
    'payment.failed': 'Zahlung gescheitert bitte kontaktieren Sie office@quip.eu',
    'payment.description': 'Die Zahlung erfolgt auf Rechnung. Nach Klick auf "Weiter zur Zahlung" wird Ihre Rechnung erstellt; bestätigen Sie den Vorgang, um die Anmeldung abzuschließen.',
    'payment.aboutOrderNumber': 'Damit wir Ihnen eine E-Rechnung ausstellen können benötigen wir Ihre LeitwegID. Geben Sie die LeitwegID in die Textbox ein und bestätigen Sie diese mit einem Klick auf den Button „LEITWEGID HINZUFÜGEN“. Ihre Buchhaltungsabteilung kann Ihnen mehr Informationen bezüglich Ihrer LeitwegID geben. Sie können die LeitwegID zu einem späteren Zeitpunkt hinzufügen und anschließend die E-Rechnung herunterladen.',
    'payment.inProcess': 'Zahlung in Bearbeitung. Bitte versuchen Sie, die Rechnung in wenigen Minuten herunterzuladen',
    'payment.enrollmentPending': 'Ihre Anmeldung ist zur Zulassung anhängig. Bis dahin konnten wir noch keine Zahlung verarbeiten.',
    'help.dialogStep': 'Hilfe',
    'help.complaint': 'Feedback Geben',
    'help.complaintStep': 'Feedback',
    'help.complaintFormHint': 'Bitte geben Sie Ihr Feedback hier ein.',
    'help.complaintSend': 'Feedback Senden',
    'help.complaintSent': 'Feedback wurde gesendet.',
    'enrollmentsmanager.headline': 'Ausstehende Zahlungen',
    'enrollmentsmanager.confirmationButtonLabel': 'Bezahlt',
    'enrollmentsmanager.confirmationTitle': 'Bitte wählen Sie um fortuzufahren',
    'enrollmentsmanager.confirmationCancel': 'Abbruch',
    'enrollmentsmanager.confirmationProceed': 'OK',
    'enrollmentsmanager.confirmationText': 'Sind sie sicher?',
    'enrollmentsmanager.goToSurvey': 'Zum Fragebogen',
    'enrollmentsmanager.detailedEvaluationPrintButton': 'Drucken',
    'enrollmentsmanager.detailedEvaluationButton': 'Auswertung',
    'enrollmentsmanager.detailedEvaluation': 'Auswertung für Ringversuch {trial}',
    'enrollmentsmanager.overallEvaluation': 'Gesamtauswertung',
    'enrollmentsmanager.invoiceDialogOpenButton': 'Rechnung',
    'enrollmentsmanager.invoiceDialogTitle': 'Rechnung',
    'enrollmentsmanager.downloadInvoiceButton': 'Rechnung Herunterladen',
    'enrollmentsmanager.downloadEInvoiceButton': 'E-Rechnung Herunterladen',
    'enrollmentsmanager.orderNumberTextFieldLabel': 'LeitwegID',
    'enrollmentsmanager.orderNumberExistsTextFieldLabel': 'Zuvor eingegebene Auftragsnummer.',
    'enrollmentsmanager.orderNumberWarningText': 'Sind Sie sicher, dass Sie keine Auftragsnummer auf Ihrer Rechnung benötigen? Es ist nicht möglich diese zu einem späteren Zeitpunkt hinzuzufügen.',
    'enrollmentsmanager.cancelledInvoices': 'Stornierte Rechnungen',
    'enrollmentsmanager.trialCancelledHeading': 'Ringversuch Storniert',
    'enrollmentsmanager.trialCancellationNote': 'Ihre Teilnahme an diesem Ringversuch wurde storniert.',
    'enrollmentsmanager.passedSubmissions': 'Anzahl bestandener Teilnahmen',
    'enrollmentsmanager.passedSubmissionsSection': 'Anzahl bestandener Teilnahmen (Sektion)',
    'enrollmentsmanager.quotaPassedSubmissions': 'Erfolgsquote',
    'enrollmentsmanager.pointsAchieved': 'Erreichte Punkte',
    'enrollmentsmanager.pointsAfterReview': 'Punkte nach Review',
    'enrollmentsmanager.pointsAchievedWithReview': 'Review-Punkte',
    'enrollmentsmanager.faerbungAdditionalInfo': ' (Färbung + Nachbegutachtung)',
    'enrollmentsmanager.sectionScore': 'Punkte pro Sektion',
    'enrollmentsmanager.totalScore': 'Gesamtpunkte',
    'enrollmentsmanager.reviewSubmission': 'Einreichungen einsehen',
    'enrollmentsmanager.setInvoiceNumber': 'LeitwegID hinzufügen',
    'enrollmentsmanager.invoiceNumberSet': 'Die Rechnungsnummer wurde festgelegt',
    'enrollmentsmanager.postResubmitExpired': 'Die Einreichung Ihrer Revision ist abgelaufen',
    'enrollmentview.pendingapproval': 'Die Teilnahme steht zur Genehmigung an',
    'enrollmentview.trialhasnotstarted': 'Ringversuch hat nicht begonnen oder ist beendet',
    'trialmanagement.downloadInvoices': 'Rechnungen',
    'trialmanagement.headline': 'Verwaltung Ringversuche',
    'trialmanagement.newTrialButton': 'Ringversuch anlegen',
    'trialmanagement.editTrialButton': 'Ringversuch editieren',
    'trialmanagement.saveChangesButton': 'Änderungen speichern',
    'trialmanagement.uploadManual': '+ Anleitung',
    'trialmanagement.createParticipantsList': 'Liste der Teilnehmer',
    'trialmanagement.uploadDeliveryListButton': '+ Auslieferungsliste',
    'trialmanagement.uploadDeliveryListFailed': 'Auslieferungsliste Hochladen Fehlgeschlagen',
    'trialmanagement.uploadButton': 'Hochladen',
    'trialmanagement.browseButton': 'Auswählen',
    'trialmanagement.selectedFiles': 'Selektierte Dateien',
    'trialmanagement.fileUploadDialogTitle': 'Anleitung zum Ringversuch hochladen',
    'trialmanagement.fileUploadDialogDescription': 'Bitte wählen Sie eine Datei von Ihrem Computer zum hochladen aus',
    'trialmanagement.editGroundTruth': 'Ground Truth',
    'trialmanagement.details': 'Ringversuch Details',
    'trialmanagement.goToSurvey': 'Fragebogen',
    'trialmanagement.createBookingsList': 'Buchhaltungsliste',
    'trialmanagement.createCertificates': 'Zertifikate erstellen',
    'trialmanagement.fetchingEnrollments': 'Anmeldungen werden abgerufen',
    'trialmanagement.certificateProcess': 'Zertifikate erstellen ... ',
    'trialmanagement.certificateProcessCompleted': 'Zertifikatserstellung abgeschlossen',
    'trialmanagement.notifyCancelCertificate': 'Bitte unapproven Sie zuerst alle Zertifikate für die Ringversuchen.',
    'trialmanagement.exportSubmissions': 'Einreichungen',
    'trialmanagement.exportEvaluations': 'Evaluationsexport',
    'trialmanagement.surveyUnavailable': 'Survey nicht verfügbar',
    'trialmanagement.surveyEditorUnavailable': 'Diese Funktion steht bei früheren alten Umfragen nicht zur Verfügung.',
    'trialmanagement.createEditSurvey': 'Fragebogen anlegen/bearbeiten',
    'trialmanagement.exitBeforeSaving': 'Sind Sie sicher, dass Sie gehen wollen, bevor Sie Ihre Änderungen sparen?',
    'trialmanagement.excelImportMissingKundennummer': 'Die Spalte mit dem Namen "kundennummer" wurde nicht gefunden. Bitte überprüfen Sie auf Rechtschreibfehler.',
    'trialmanagement.excelImportMissingColumn': 'Keine Spalte "setnummer" oder "groundtruth" gefunden. Bitte setzen Sie entweder eine oder beide Spalten.',
    'trialmanagement.emptyKundennummer': 'Leere Kundennummer in Zeile {rowNumber} gefunden',
    'trialmanagement.uploadTerms': 'Modalitäten hochladen',
    'groundtruthview.unapproveCertificate': 'Bitte unapproven Sie zuerst alle Zertifikate für die Ringversuch, um die Grundwahrheit zu bearbeiten.',
    'groundtruthview.minimalScore': 'Erforderliche Gesamtpunktzahl',
    'groundtruthview.evaluationFormulaHeadline': 'Auswertungsformel Sektion',
    'groundtruthview.evaluationFormulaPlaceholder': 'Bspw. q1 * (q1 + q2 + q3)',
    'groundtruthview.evaluationFormula': 'Formel (optional)',
    'groundtruthview.submittedGroundTruth': 'Erfolgreich übermittelt',
    'groundtruthview.minimumScoreSection': 'Mindestpunktzahl für Sektion',
    'groundtruthview.considerInGroundTruth': 'In Groundtruth berücksichtigen',
    'groundtruthview.considerOptionalSection': 'Optionaler Sektion (die Punkte werden bewertet, tragen aber nicht zum Bestehen oder Nichtbestehen der Ringversuch bei)',
    'groundtruthview.evaluationInReview': ' - Punkte via Reviewtool - ',
    'groundtruthview.passedPercentage': 'Bestehensgrenze in %',
    'groundtruthview.maximumScore': 'Maximalpunktzahl',
    'groundtruthview.minimumScore': 'Mindestpunktzahl',
    'groundtruthview.mainSettings': 'Einstellungen der Ground Truth',
    'groundtruthmultiplechoice.unitymessage': 'Der Einheitsscore zählt nur dann alle Punkte pro Fall, wenn die Teilnehmer ALLE Optionen korrekt beantworten.',
    'groundtruthview.manageGroundtruth': 'Ground Truths verwalten',
    'groundtruthview.deleteConfirm': 'Möchten Sie diese Groundtruth wirklich löschen?',
    'groundtruthview.selectDelete': 'Bitte wählen Sie den Groundtruth aus der Dropdown-Liste aus, um ihn zu löschen',
    'groundtruthview.optionalSectionEnabled': 'Optionale Abschnitte sind aktiviert und der Benutzer kann sich von der Teilnahme an jedem Abschnitt abmelden. Bitte legen Sie die Gesamtpunkte nach Ihren Bedürfnissen fest',
    'groundtruth.title': 'Bestätigen Löschen Ground-Truth',
    'groundtruth.message': 'Sind Sie sicher, dass Sie diese Ground-Truth Löschen möchten?',
    'editTrial.headline': 'Ringversuch editieren',
    'faerbung.criteria': 'Kriterien',
    'faerbung.sensitivity': 'Sensitivität / Reaktionsstärke',
    'faerbung.specifity': 'Spezifität, Präparatequalität + Gewebeerhaltung',
    'feedback.headline': 'Erfolgreich übermittelt:',
    'feedback.starRatingDescription': 'Bitte wählen Sie eine Anzahl an Sternen um den Ringversuch zu bewerten - (1: schlecht - 5: sehr gut)',
    'feedback.textFieldHeading': 'Ihr Kommentar',
    'feedback.submitRating': 'Bewertung Absenden',
    'feedback.backHome': 'Zum Dashboard',
    'feedback.titleIntro': 'Anonymes Feedback für den Ringversuch: {trialName} (keine Angaben zu Ringversuchsproben)',
    'feedback.note': 'Ihr Feedback wird anonymisiert ausgewertet. Wenn Sie eine Rückmeldung wünschen, kontaktieren Sie uns bitte direkt unter ',
    'mysurvey.sampleId': 'Objectträger Id',
    'mysurvey.emptySectionWarningText': 'Dieser Ringversuch besteht aus mehreren Sektionen, welche Sie über die Reiter oberhalb des Fragebogens anwählen können. Sie haben Fragen zu mindestens einem dieser Sektionen nicht beantwortet.',
    'mysurvey.emptySectionWarningQuestion': 'Wollen Sie dennoch fortfahren?',
    'containerdownload.message': 'Hier klicken, um die angeforderte Datei herunterzuladen',
    'containerdownload.download': 'herunterladen',
    'containerdownload.cancel': 'abbrechen',
    'trialtable.upcomingStatus': 'Registrierung geschlossen. RV bevorstehend',
    'trialtable.registrationUpcomingStatus': 'Registrierung bevorstehend',
    'trialtable.registrationStatus': 'Registrierung offen',
    'trialtable.ongoingStatus': 'RV in Bearbeitung',
    'trialtable.pendingStatus': 'RV in Auswertung',
    'trialtable.finished': 'RV abgeschlossen',
    'trialtable.waitingForStart': 'Registrierung erfolgreich. Warten auf RV Start',
    'trialtable.unknownStatus': 'unbekannter Status',
    'userDetails.userDataHeading': 'Nutzerkonto',
    'userDetails.userDataHeading.helpTitle': 'Nutzerkonto Hilfe',
    'userDetails.userDataHeading.helpText': 'In dieser Sektion können Sie Ihre Nutzerdaten einsehen und ändern.',
    'userDetails.title': 'Titel',
    'userDetails.firstname': 'Vorname',
    'userDetails.surname': 'Nachname',
    'userDetails.position': 'Position',
    'userDetails.realm': 'Bereich',
    'userDetails.activated': 'Aktiviert',
    'userDetails.username': 'Nutzername',
    'userDetails.email': 'E-Mail',
    'userDetails.emailVerified': 'E-Mail Bestätigt',
    'userDetails.notificationOptOut': 'Benachrichtigungen per E-Mail deaktivieren',
    'userDetails.editUser': 'Benutzer bearbeiten',
    'submissions.headline': 'Teilnahmen',
    'submissions.headline.helpTitle': 'Übermittelungen Hilfe',
    'submissions.headline.helpText': 'In dieser Sektion können Sie alle Ihre Übermittlungen einsehen',
    'submission.saved': 'gespeichert',
    'submission.saving': 'speichern läuft...',
    'submission.incomplete': 'Bitte füllen Sie das Textfeld aus, sonst werden Ihre Eingaben nicht gespeichert',
    'submission.saveFailedEndDate': 'Die Einreichung wurde nicht abgeschlossen. Der Ringversuch ist beendet. Bitte kontaktieren Sie den Administrator',
    'instituteView.headline': 'Institut',
    'instituteView.instituteBrief': 'Zusammenfassung',
    'instituteView.instituteDataHeading': 'Versandadresse/Rechnungsadresse/Zertifizierungsadresse',
    'instituteView.instituteDataHeading.helpTitle': 'Institutsdaten Hilfe',
    'instituteView.instituteDataHeading.helpText': 'In dieser Sektion können Sie Ihre Daten zum Institut, der Rechnungsadresse und Zertifizierungsadresse einsehen und ändern.',
    'instituteView.editInstitute': 'Versandadresse/Rechnungsadresse/Zertifizierungsadresse bearbeiten',
    'instituteView.registerNewInstitute': 'Institut anmelden',
    'instituteView.noInstituteAssigned': 'Ihr Account wurde vom Administrator noch mit keinem Institut verknüpft. Bitte versuchen Sie es später wieder.',
    'instituteEditDialog.edit': 'Ändern der Institutsdaten',
    'instituteEditDialog.instituteDataHeading': 'Institutsanschrift und Versandadresse für das Testset',
    'instituteEditDialog.invoiceDataHeading': 'Rechnungsdaten (optional)',
    'instituteEditDialog.certificationDataHeading': 'Zertifikatsdaten (optional)',
    'certificatesView.getCertificate': 'Zertifikat',
    'certificatesView.createCertificate': 'Erzeugen',
    'certificatesView.certificateAvailable': 'Zertifikat verfügbar',
    'certificatesView.submissionMissing': 'Keine Einreichung',
    'certificatesView.groundTruthMissing': 'In Auswertung',
    'certificatesView.unknownState': 'Unbekannt',
    'certificatesView.certificateIssued': 'Zertifikat ausgestellt',
    'certificatesView.pendingCertificates': 'Aktuelle Zertifikate',
    'certificatesView.pendingCertificates.helpTitle': 'Aktuelle Zertifikate Hilfe',
    'certificatesView.pendingCertificates.helpText': 'In dieser Sektion können Sie Zertifikate für bestandene Ringversuche erstellen.',
    'certificatesView.acquiredCertificates': 'Erworbene Zertifikate',
    'certificatesView.acquiredCertificates.helpTitle': 'Erworbene Zertifikate Hilfe',
    'certificatesView.acquiredCertificates.helpText': 'In dieser Sektion können Sie erworbene Zertifikate einsehen und herunterladen.',
    'certificatesView.blockCertificateMessage': 'Ihr Zertifikat ist fertig, muss jedoch noch von Quip genehmigt werden. Bitte kontaktieren Sie Quip für weitere Informationen.',
    'certificate.uploadCertificate': 'Zertifikat hochladen',
    'certificate.uploadWarning': 'Bereits vorhandenes Zertifikat wird entfernt',
    'customfieldeditor.fieldSetName': 'Name der Schablone',
    'customfieldeditor.newOption': 'Eingabe einer neuen Option',
    'customfieldeditor.addOptionButton': 'Option hinzufügen',
    'customfieldeditor.changeOptionButton': 'Ändern',
    'customfieldeditor.question': 'Was ist die Frage zur Auswahlbox',
    'customfieldeditor.headline': 'Überschrift der Auswahlbox',
    'customfieldeditor.editHeadline': 'Auswahlbox editieren',
    'customfieldeditor.previewHeadline': 'Vorschau auf Auswahlbox',
    'customfieldeditor.saveAsHeadline': 'Speichern als Schablone',
    'customfieldeditor.saveButton': 'Speichern',
    'customfieldeditor.resetButton': 'Neu',
    'configurecustomfields.availableSetsHeadline': 'Verfügbare Schablonen',
    'configurecustomfields.configuredSets': 'Konfigurierte Auswahlboxen',
    'configurecustomfields.addButton': 'Hinzufügen',
    'downloadView.downloadNotAvailable': 'Der Download ist nicht verfügbar, bitte kontaktieren Sie office@quip.eu',
    'survey.generalCommentHeading': 'Allgemeine Anmerkung',
    'survey.finaliseDialogHeading': 'Einreichung abschließen',
    'survey.goToIncompleteSection': 'Zur unvollständigen Sektion gehen',
    'survey.reviewSubmission': 'Einreichung überprüfen',
    'survey.confirmFinalisationButtonLabel': 'Einreichung abschließen',
    'survey.cancelSubmitSubmission': 'Schließen ohne Speichern',
    'survey.backToEnrollments': 'Zurück',
    'survey.finalisationWarning': 'Wenn Sie den Einreichung abschließen sind keine Änderungen mehr möglich. Ihre Abgabe ist somit final. Bitte vergewissern Sie sich, dass Ihre Antworten vollständig sind.',
    'survey.finalisedNote': 'Sie haben den Ringversuch abgeschlossen. Keine weiteren Änderungen möglich.',
    'survey.surveyHighlight': 'Der Fragebogentext wurde aktualisiert. Klicken Sie hier, um die Highlights zu überprüfen',
    'survey.saved': 'Eingabe gespeichert',
    'survey.saveFailed': 'Eingabe wurde nicht gespeichert',
    'survey.finalizedFailed': 'Die Eingabe kann nicht abschließend bearbeitet werden, bitte kontaktieren Sie die Admin.',
    'survey.notComplete': 'Bitte überprüfen Sie die rot markierten Fragen und geben Sie eine Antwort ein. Bei Freitextfragen geben Sie bitte ein Minus ein, wenn die Frage nicht zutrifft.',
    'survey.deleteShareLink': 'Teilen beenden',
    'survey.participateOptOut': 'von der Teilnahme abmelden',
    'survey.optOutWarningTitle': 'Abmelden (Opt-out) von "{sectionName}"',
    'survey.optOutWarning': 'Sind Sie sicher, dass Sie sich von dieser Sektion abmelden (Opt-out) möchten? Alle von Ihnen eingereichten Einträge für diesen Bereich werden entfernt. Sie können dieses Verhalten rückgängig machen, indem Sie auf das gleiche Kontrollkästchen klicken. ACHTUNG: Ihre Einträge werden NICHT wiederhergestellt!',
    'survey.optOut': 'Abmelden (Opt-out) von dieser Sektion',
    'survey.labelOptout': 'Abmelden (Opt-out): ',
    'survey.confirmOptOut': 'Wenn Sie sich abmelden, werden die aktuellen Einreichungseinträge in diesem Abschnitt entfernt',
    'survey.compulsoryWarn': 'Eine oder mehrere Pflichtfragen sind unbeantwortet. Bitte beantworten Sie alle Pflichtfragen. Sie können sich auch abmelden, wenn der Sektion dies erlaubt.',
    'survey.submitInfo': 'Durch Klicken auf die Schaltfläche „Abschicken“ bestätigen Sie das Absenden dieser Umfrage. Weitere Änderungen an Ihren Antworten sind nicht möglich.',
    'survey.methodologicalSelector': 'Methodische Fragen',
    'survey.optionalSection': 'Diese Sektion ist nicht bestehensrelevant.',
    'surveyHighlight.oldText': 'Alter Text war',
    'surveyHighlight.updatedAt': 'Aktualisiert am',
    'textblock.uploadTextBlockComments': 'Textblockkommentare hochladen',
    'trialsenrolled.warningheadline': 'Sie sind bereits für diesen Ringversuch angemeldet.',
    'trialsenrolled.content': 'Sie haben sich bereits für diesen Ringversuch {trialName} angemeldet. Für genauere Informationen gehen Sie bitte zu Teilnahmen & Rechnungen. Möchten Sie damit fortfahren?',
    'trialsenrolled.contentDRT': 'Sie haben sich bereits für diesen Digital Readout Test {trialName} angemeldet. Für genauere Informationen gehen Sie bitte zu Teilnahmen & Rechnungen. Möchten Sie damit fortfahren?',
    'instituteEditDialog.inputMissing': 'Bitte Eingabe vervollständigen',
    'review.assignedReviewsHeadline': 'Angeforderte Reviews ({amount})',
    'review.submissionsHeadline': 'Einreichungen {trial}',
    'review.reviewSubmissionButton': 'Review',
    'review.submissionHeadline': 'Einreichung von {user}',
    'review.reviewHeadline': 'Ihre Bewertung',
    'review.submitReviewSubmission': 'Bewertung speichern',
    'review.cancelReviewSubmission': 'Zurück',
    'review.justificationHeading': 'Ihre Gesamtbeurteilung (Fazit)',
    'review.sectionJustificationHeading': 'Ihre Begründung für diese Sektion',
    'review.methodicalQuestionTitle': 'Methodische Fragen',
    'review.reviewManagement': 'Reviewer verwalten',
    'review.showOpenQuestions': 'Methodische Fragen einsehen',
    'review.noOpenQuestions': 'Keine methodischen Fragen',
    'review.contextOpenQuestionsSubheadline': 'Für aktuelle Sektion: {name}',
    'review.trialOpenQuestionsSubheadline': 'Für gesamten Fragebogen',
    'review.anonymizeHeader': 'Setnummer der Einreichung',
    'review.printAll': 'Alles drucken',
    'review.printSettings': 'Druckeinstellungen',
    'review.questionsLayout': 'Fragen Layout',
    'review.printHorizontalQuestion': 'Stellen Sie die Fallnummern horizontal ein',
    'review.printVerticalQuestion': 'Stellen Sie die Fallnummern vertikal ein',
    'review.sectionBreak': 'neue Seite pro Sektion',
    'review.unavailable': 'Entweder gab es keine Einreichungen für dieser Ringversuch oder die Bewertung wurde nicht abgeschlossen.',
    'review.displayOptions': 'Anzeigeoptionen',
    'review.displayAllQuestions': 'Alle Fragen anzeigen',
    'review.displayAnsweredQuestions': 'Nur beantwortete Fragen anzeigen',
    'review.notfinalized': 'Diese Eingabe ist vom Benutzer noch nicht abgeschlossen',
    'review.faerbungReviewTitle': 'Färbung Review',
    'review.sectionCommentHeadline': 'Sektion Kommentar',
    'review.surveyCommentHeadline': 'Gesamtkommentar',
    'review.addCommentSection': 'Kommentar zu dieser Sektion hinzufügen',
    'review.addCommentSurvey': 'Kommentar zu diesem Fragebogen hinzufügen',
    'reviewmanagement.removeAssignment': 'entfernen',
    'reviewmanagement.removeAssignments': 'Review Anfragen entfernen von {trial}',
    'reviewmanagement.addAssignments': 'Reviewer hinzufügen zu {trial}',
    'reviewmanagement.selectedReviewer': 'Reviewer auswählen',
    'reviewmanagement.addAssignment': 'Reviewer hinzufügen',
    'reviewmanagement.multiCommentWarning': 'Kommentar Daten sind bereits in der Überprüfung dieser Ringversuch vorhanden. Durch das Hochladen neuer Daten werden alle Kommentare in bereits vorhandenen Überprüfungen dieser Ringversuch entfernt.',
    'reviewmanagement.passStatus': 'Der Teilnehmer hat mit {points} Punkten bestanden',
    'reviewmanagement.failStatus': 'Der Teilnehmer hat mit {points} Punkten nicht bestanden',
    'textblock.uploadSuccess': 'Erfolgreich hochgeladen',
    'review.openQuestionsHeadline': 'Offene Fragen',
    'review.minScoreHeadline': 'Mindestpunktzahl',
    'review.obtainedScoreHeadline': 'Erhaltene Punktzahl',
    'review.reviewScoreHeadline': 'Punktzahl nach Review',
    'review.sectionStainingReview': 'Sektion Färbungreview: ',
    'review.surveyStainingReview': 'Gesamt Färbungreview: ',
    'review.resetReview': 'Review zurücksetzen',
    'review.obtainedScoreDialog': 'Erhaltene Punkte',
    'review.reviewScoreDialog': 'Review Punkte',
    'review.sectionStatus': 'Sektion Status: ',
    'review.overallStatus': 'Gesamt Status: ',
    'review.questionHeadline': 'Fallbezogene Fragen',
    'review.title': 'Bestätigen Löschen Review Score',
    'review.submittedAnswer': 'Eingereichte Antwort',
    'review.gtAnswer': 'Sollwerte',
    'review.message': 'Sind Sie sicher, dass Sie diese Review Score Löschen möchten?',
    'review.noReview': 'Keine Review Punkte',
    'evaluationdialog.reviewsection': 'Review Kommentare',
    'evaluationdialog.noSubmissions': 'Für diese Anmeldung liegen keine Einreichungen vor',
    'evaluationdialog.optionalSection': 'Dies ist ein optionaler Abschnitt und seine Noten haben keinen Einfluss auf die Gesamtpunktzahl oder das Ergebnis der Umfrage',
    'declareReviewers.addReviewerButton': 'Reviewer ernennen',
    'declareReviewers.removeReviewerButton': 'Reviewer entfernen',
    'reviewdialog.headline': 'Review',
    'admindetails.geocodeUnlocatedInstitutesHeadline': 'Kartenposition aller Institute',
    'admindetails.geocodeUnlocatedInstitutesButton': 'Positionen ergänzen',
    'createeditsurveyview.newsection': '+ Sektion',
    'createeditsurveyview.settings': 'Einstellungen',
    'createeditsurveyview.trialHasStaredMessage': 'Der Ringversuch hat begonnen, die Bearbeitung dieser Umfrage ist begrenzt',
    'createeditsurveyview.resetGroundTruth': 'Die Umfrage wurde geändert. Durch das Speichern wird die zuletzt eingegebene Ground Truth zurückgesetzt',
    'sectioneditor.sectionheadline': 'Sektionsname',
    'sectioneditor.numofcases': 'Fallzahl',
    'questionscontainer.addquestion': '+ Fallbezogene Fragen',
    'questionscontainer.addcontextquestion': '+ Methodische Fragen',
    'questiontypelist.title': 'Fragetyp auswählen',
    'questionlist.options': ' Antwortoptionen',
    'questioneditor.questiontext': 'Frage-Text',
    'questioneditor.required': ' Pflichtfrage',
    'questioneditor.addnewoption': '+ Antwortoptionen',
    'questioneditor.enabledetailquestion': 'Detaillierte Frage aktivieren',
    'questioneditor.placeholdertext': 'Platzhalter eingeben',
    'questioneditor.clicktoeditdetailquestion': 'Klicken Sie zum Bearbeiten der Detailfrage',
    'questionEditor.hideAggregation': 'Frage aus der Auswertung ausblenden',
    'questionEditor.hideAggregationTooltip': 'Frage vor der Auswertung verborgen',
    'questionEditor.technicallyNotEvaluable': 'Technisch nicht auswertbar',
    'questionEditor.enableTNA': '"Technisch nicht auswertbar" Aktivieren',
    'questionEditor.changeType': 'Typ ändern',
    'surveysettings.numberofsections.1': 'Dieser Fragebogen enthält ',
    'surveysettings.numberofsections.2': ' sektion/sektionen',
    'surveysettings.setOptionalSurveys': 'Umfrageabschnitte optional für die Einreichung festlegen',
    'sectionSettings.optionalSection': 'Optional Section (Sektion ist nicht bestehensrelevant)',
    'sectionSettings.optOut': 'Opt-out aktivieren',
    'surveyDuplicate.copySurvey': 'Fragebogen kopieren',
    'surveyDuplicate.replicateSurvey': 'Fragebogen aus vorhandenem Fragebogen replizieren',
    'voucher.redeemVoucher': 'Gutschein einlösen',
    'voucher.couponCode': 'Gutscheincode',
    'voucher.techPdf': 'Technische Informationen und Anweisungen',
    'voucher.proceedLogin': 'Um mit dem Registrierungsprozess fortzufahren, melden Sie sich bitte mit Ihrem persönlichen Konto an',
    'voucher.continueAs': 'weiter als',
    'voucher.loginDiffernt': 'Melden Sie sich mit einem anderen Konto an',
    'voucher.login': 'Anmelden',
    'voucher.signup': 'Registrieren',
    'voucher.invalidCode': 'Dieser Gutscheincode ist leider nicht gültig, bitte geben Sie einen gültigen Gutscheincode ein',
    'voucher.codeReedemed': 'Dieser Gutscheincode ist bereits eingelöst. Bitte wenden Sie sich an den Quip-Support',
    'voucher.voucherManagement': 'Gutscheinverwaltung',
    'voucher.voucherEnrollManagement': 'Verwaltung der Gutscheinregistrierung',
    'voucher.upload': 'Gutscheine hochladen',
    'voucher.invalidCodeLength': 'Jeder Code muss zhen Zeichen lang sein',
    'voucher.invalidFormatting': 'falsches Codeformat. Bitte achten Sie auf die richtige Formatierung: xxxx-xxxxxx',
    'voucher.claimedOn': 'beansprucht am',
    'voucher.finalizeMessage': 'Um die Anmeldung abzuschließen, klicken Sie bitte auf „ZUR ANMELDUNG“',
    'voucher.incompatible': 'Dieser Ringversuch ist nicht als gutscheinkompatibel gekennzeichnet',
    'voucher.acceptEverything': 'Ich akzeptiere',
    'voucher.acceptTerm1': 'Bitte akzeptieren Sie unsere',
    'voucher.acceptTerm2': 'Allgemeinen Geschäftsbedingungen',
    'voucher.acceptModality1': 'und die für dieses QuIP-Produkt zutreffenden',
    'voucher.acceptModality2': 'Modalitäten',
    'voucher.alreadyEnrolled': 'Sie sind bereits für diesen Ringversuch angemeldet',
    'voucher.enrollmentStatus': 'Registrierungsstatus',
    'voucher.trialFull': 'Dieser Ringversuch ist bereits voll. Bitte wenden Sie sich an den Quip-Support',
    'feedback.feedbackView': 'Feedback',
    'feedback.export': 'Feedback exportieren',
    'internalTrial.enroll': 'Internen Benutzer registrieren',
    'internalTrial.enrollUser': 'Benutzer registrieren',
    'internalTrial.bulkRegister': 'Massenregistrierung',
    'internalTrial.bulkStep1': 'CSV hochladen',
    'internalTrial.bulkStep2': 'Ergebnisse herunterladen',
    'internalTrial.bulkStep3': 'Teilnehmer registrieren',
    'internalTrial.bulkStep1Description': 'Laden Sie eine CSV- oder Excel-Datei hoch, die eine Spalte "email" enthält. Es wird nur diese Spalte verwendet; doppelte E-Mails werden einmal verarbeitet.',
    'internalTrial.bulkStep1SkipHint': 'Bereits eine Phase-2-Datei? Direkt zur Teilnehmerregistrierung.',
    'internalTrial.bulkSkipToRegister': 'Zur Teilnehmerregistrierung',
    'internalTrial.bulkStep2Description': 'Laden Sie die Ergebnisse (Matched- und Unmatched-Blätter) herunter und fahren Sie dann fort.',
    'internalTrial.bulkStep3Description': 'Laden Sie die heruntergeladene Datei (Phase-2-Format mit Matched-Blatt) erneut hoch. Geben Sie unten den exakten Ringversuchsnamen zur Bestätigung ein und klicken Sie auf Registrieren.',
    'internalTrial.bulkSummary': '{matched} gefunden, {unmatched} nicht gefunden',
    'internalTrial.bulkDownload': 'Ergebnisse herunterladen',
    'internalTrial.bulkNext': 'Weiter',
    'internalTrial.bulkTrialNameLabel': 'Ringversuchsname (exakt, Groß-/Kleinschreibung beachten)',
    'internalTrial.bulkRegisterConfirm': 'Teilnehmer registrieren',
    'internalTrial.bulkImportMissingEmailColumn': 'Die Datei muss eine Spalte "email" enthalten.',
    'internalTrial.bulkImportNoEmails': 'Keine gültigen E-Mails in der Datei gefunden.',
    'internalTrial.bulkImportError': 'Datei konnte nicht verarbeitet werden.',
    'internalTrial.bulkEnrollMissingQidColumn': 'Die Datei muss eine Spalte "Quip Id" oder "QID" enthalten (vom Phase-2-Download).',
    'internalTrial.bulkEnrollNoValidQids': 'Keine gültigen Quip-Ids in der Datei gefunden.',
    'internalTrial.bulkTrialNameMismatch': 'Ringversuchsname stimmt nicht überein. Geben Sie den exakten Namen ein, um Fehler zu vermeiden.',
    'internalTrial.bulkReuploadRequired': 'Bitte laden Sie die Datei (Phase-2-Format) zum Registrieren hoch.',
    'internalTrial.bulkEnrollError': 'Massenregistrierung fehlgeschlagen.',
    'internalTrial.bulkEnrollPartial': 'Einige Registrierungen sind fehlgeschlagen.',
    'internalTrial.bulkEnrollResult': 'Registriert: {enrolled}, Fehlgeschlagen: {failed}',
    'internalTrial.bulkEnrollResultWithSkipped': 'Registriert: {enrolled}, Übersprungen (bereits registriert): {skipped}, Fehlgeschlagen: {failed}',
    'internalTrial.bulkBackToDownload': 'Zurück zu Ergebnissen',
    'internalTrial.notifyRegisteredUsers': 'Registrierte Benutzer benachrichtigen',
    'internalTrial.notifyRegisteredUsersLoading': 'Teilnehmer werden geladen…',
    'internalTrial.notifyNoRegisteredUsers': 'Es gibt noch keine freigegebenen Anmeldungen.',
    'internalTrial.notifyColQid': 'Quip-Id',
    'internalTrial.notifyColName': 'Name',
    'internalTrial.notifyColInstitute': 'Institut',
    'internalTrial.notifyColForwardAddresses': 'Benachrichtigungs-Weiterleitungen',
    'internalTrial.notifyColEmail': 'E-Mail',
    'internalTrial.notifySendEmail': 'E-Mail senden',
    'internalTrial.notifySelectAll': 'Alle Benutzer auswählen',
    'internalTrial.notifySendPrepared': 'Benachrichtigungen erfolgreich vorbereitet.',
    'internalTrial.notifySendError': 'Benachrichtigungen konnten nicht vorbereitet werden.',
    'usermanagement.nothingToDo': 'Es gibt hier nichts zu tun',
    'usermanagement.resendActivation': 'Aktivierung versenden',
    'usermanagement.deleteUser': 'Benutzer Löschen',
    'usermanagement.deleteUserConfirmationTitle': 'Benutzer löschen bestätigen',
    'usermanagement.deleteUserConfirmationText': 'Sind Sie sicher, dass Sie folgenden Nutzer löschen wollen: ',
    'userManagement.updateInstitute': 'Institut aktualisieren',
    'userManagement.updateInstituteForUser': 'Update-Institut für Benutzer',
    'userManagement.assignInstitute': 'Institut zuweisen',
    'instituteManagement.instituteManagement': 'Institutsleitung',
    'instituteManagement.registeredUsers': 'Registrierte Benutzer',
    'instituteManagement.registerdInstitutes': 'Registrierte Institute',
    'instituteManagement.confirmDelete': 'Sind Sie sicher, dass Sie dieses Institut löschen möchten?',
    'instituteManagement.showUsers': 'Benutzer anzeigen',
    'instituteUser.addUsers': 'Benutzer hinzufügen',
    'enrollment.recordNotFound': 'Kein Anmelder gefunden',
    'enrollment.userNotVerfied': 'Benutzer nicht verifiziert',
    'enrollment.userDeactivated': 'Benutzer deaktiviert',
    'enrollment.noUserFromQuip': 'Keine Registrierung für QuIP- Nutzer. Die meisten QuIP- Nutzer sind Administratoren und die Einreichung von Studien wird für diese Rollen nicht unterstützt.',
    'DRT.confirmDeleteSection': 'Durch das Löschen des Abschnitts werden auch seine Fälle gelöscht',
    'DRT.gtRangeError': 'Bitte stellen Sie sicher, dass der minimale Bereichswert nicht größer ist als der maximale Bereichswert',
    'DRT.gtNumberError': 'Bitte stellen Sie sicher, dass es sich bei allen Werten um Zahlen mit bis zu zwei Dezimalstellen handelt',
    'DRT.noRegularEnroll': 'Um an regulären Ringversuchen teilnehmen zu können, benötigen Sie die Zugehörigkeit zu einem Institut. Bitte tragen Sie die fehlenden Institutsdaten dafür unter „Nutzerdaten“ in Ihrem internen Bereich ein und warten Sie auf Freigabe durch QuIP.',
    'DRT.startExam': 'Bitte wählen Sie einen Antikörper für die Durchführung des Tests aus. Den Antikörper können Sie nicht mehr ändern. Wenn Sie fortfahren, starten Sie den Digital Readout Test. Sie haben insgesamt X min Zeit um den Digital Readout durchzuführen, können jedoch jederzeit pausieren.',
    'DRT.continueExam': 'Möchten Sie nun mit dem Digital Readout Test fortfahren? Es verbleiben noch X min in Ihrem Zeitkontingent zur Durchführung.',
    'DRT.finalizeSubmission': 'Sind Sie sicher, dass Sie die Ergebnisse einreichen und den Digital Readout Test abschließen möchten? Nachträgliche Änderungen und eine Überprüfung Ihrer Ergebnisse sind dann nicht mehr möglich.',
    'DRT.resultNotification': 'Das ist eine Übersicht über die maximal mögliche Punktezahl und ihre  tatsächlich erreichte Punktezahl. Genauere Informationen zu Ihrem  Abschneiden im Vergleich zu den anderen Teilnehmern und den korrekten  Antworten erhalten Sie erst nach Ablauf des Durchführungszeitraums  unter Auswertung.',
    'billingAddress.add': 'Rechnungsadresse hinzufügen',
    'billingAddress.heading': 'Hinzufügen/Auswählen Ihrer Rechnungsadresse',
    'billingAddress.title': 'Rechnungsadresse(n) für personenbezogene Digital Readout Tests',
    'billingAddress.deletePrompt': 'Möchten Sie diese Rechnungsadresse wirklich löschen?',
    'billingAddress.addInstitute': 'Institutsadresse als Rechnungsadresse einrichten',
    'billingAddress.noInstitute': 'Leider haben Sie keine Institutsadresse',
    'numberRangeQuestionInput.invalidNumber': 'Bitte geben Sie eine gültige Zahl ein (z.B 1, 1.3, 1.01, bis zu zwei Dezimalstellen zulässig) oder RTU oder -',
    'ratioQuestionInput.invalidNumber': 'Bitte geben Sie eine gültiges Verhältnis ein (z.B. 1:40) oder RTU oder -',
    'answerSummary.title': 'Übersicht Antworten',
    'answerSummary.questionTitle': 'Fallbezogene Frage',
    'referencelink.title': 'Web Links',
    'referenceLink.addText': 'Web Links hinzufügen zu:',
    'referenceLink.urlError': 'Einer oder mehrere Web Links sind ungültig',
  },
};

export default translations;
